(function () {
	'use strict';

	angular.module('dcApp').controller('DepotEditController', [
		'$scope',
		'$rootScope',
		'$stateParams',
		'passedData',
		'toaster',
		'$state',
		'$filter',
		'$timeout',
		'$window',
		'$log',
		'$cookies',
		'PAGINATIONS_SIZE',
		'PAGINATIONS_SIZES',
		'DATE_TIME_PATTERN',
		'ConnectorService',
		'ConnectorV2Service',
		'DepotService',
		'DbSQLDepotService',
		'API_BASE_URL_BACKEND',
		'$http',
		'EntiteDepotService',
		'DepotExtractionFilterService',
		'TypeEntiteService',
		'DepotExtractionService',
		'CsvDepotService',
		'ParquetDepotService',
		'JsonDepotService',
		'DepotFileService',
		'ExcelDepotService',
		'$sce',
		'BinaryDepotService',
		'ParametersServices',
		'frameService',
		'MetadataService',
		'CommonServices',
		'XmlDepotService',
		'MongodbDepotService',
		'Neo4jDepotService',
		'gettextCatalog',
		'ModalService',
		'AllDepotService',
		'DepotUtils',
		'AppSelectorService',
		'RepositoryService',
		'NgDepot',
		'RepositoryHeadersService',
		'PermissionService',
		function (
			$scope,
			$rootScope,
			$stateParams,
			passedData,
			toaster,
			$state,
			$filter,
			$timeout,
			$window,
			$log,
			$cookies,
			PAGINATIONS_SIZE,
			PAGINATIONS_SIZES,
			DATE_TIME_PATTERN,
			ConnectorService,
			ConnectorV2Service,
			DepotService,
			DbSQLDepotService,
			API_BASE_URL_BACKEND,
			$http,
			EntiteDepotService,
			DepotExtractionFilterService,
			TypeEntiteService,
			DepotExtractionService,
			CsvDepotService,
			ParquetDepotService,
			JsonDepotService,
			DepotFileService,
			ExcelDepotService,
			$sce,
			BinaryDepotService,
			ParametersServices,
			frameService,
			MetadataService,
			CommonServices,
			XmlDepotService,
			MongodbDepotService,
			Neo4jDepotService,
			gettextCatalog,
			ModalService,
			AllDepotService,
			DepotUtils,
			AppSelectorService,
			RepositoryService,
			NgDepot,
			RepositoryHeadersService,
			PermissionService
		) {
			const HEADER_REFERENCING_MODE_POSITION = 'POSITION';
			const HEADER_REFERENCING_MODE_LABEL = 'LABEL';
			$scope.REPOSITORY_V2_TYPES = ['XML_V2', 'JSON_V2', 'TRINO', 'DATALINK'];
			$scope.REPOSITORY_BDD_TYPES = ['SQL', 'MONGODB', 'NEO4J', 'TRINO'];

			init();

			/**
			 * binded functions
			 */
			/*header htmlIcon*/
			$scope.getHeaderHtmlIconByType =
				RepositoryHeadersService.getHeaderHtmlIconByType;

			$scope.openUriParserModal = function () {
				if (!$scope.depot.path || $scope.depot.path === '') {
					return;
				}
				var locals = {
					title: gettextCatalog.getString('uriParser.title'),
					uri: $scope.depot.path,
				};

				ModalService.open({
					controllerAs: 'vm',
					bindToController: true,
					templateUrl:
						'./src/components/modules/depot/uri-parser/uri-parser.html',
					controller: 'UriParserController',
					disableBackdrop: true,
					locals: locals,
				}).then(function (uri) {
					$scope.depot.path = uri;
				});
			};

			$scope.openFileManagerModal = function () {
				if (
					!$scope.depot.connector &&
					!$scope.depot.connector.id &&
					!$scope.depot.connector.connector_type
				) {
					return;
				}

				let connectorId = $scope.depot.connector.id;
				let connectorType = $scope.depot.connector.connector_type;
				let connectorLabel = $scope.depot.connector.metadata
					? $scope.depot.connector.metadata.label
					: $scope.depot.connector.lib;
				let title = gettextCatalog.getString(
					'connector.remote.files.explorer',
					{
						connectorType: $filter('connectorTranslator')(connectorType),
						connectorLabel: connectorLabel,
					}
				);
				var locals = {
					title: title,
					connectorId: connectorId,
					type: connectorType,
				};

				ModalService.open({
					controllerAs: 'vm',
					bindToController: true,
					templateUrl:
						'./src/components/modules/connector/remote-file-explorer/remote-file-explorer.html',
					controller: 'RemoteFilesExplorerController',
					disableBackdrop: true,
					locals: locals,
				}).then(function (path) {
					$scope.depot.path = path;
				});
			};

			$scope.selectOrUnSelectConnector = function () {
				if ($scope.isWithConnector && passedData === null) {
					$scope.depot.connector =
						$scope.isNewDepot && $stateParams.duplicatedId == undefined
							? {}
							: $scope.depot.connector;

					$scope.depot.depot_type =
						$scope.isNewDepot && $stateParams.duplicatedId == undefined
							? undefined
							: $scope.depot.depot_type;
				} else if (!$scope.isWithConnector) {
					$scope.depot.connector = $scope.isNewDepot
						? {
								lib: $scope.localMode,
								connector_type: 'LOCAL',
								isNatif: true,
						  }
						: $scope.depot.connector;
					$scope.depot.depot_type =
						$scope.isNewDepot && $stateParams.duplicatedId == undefined
							? 'CSV'
							: $scope.depot.depot_type;
				}
				$scope.filterReaders();
			};

			$scope.filterReaders = function () {
				let connectorType = $scope.depot.connector
					? $scope.depot.connector.connector_type
					: '';
				if (connectorType !== '' && connectorType !== undefined) {
					$scope.filteredreaderTypes = _.filter(
						DepotUtils.initReaderTypes,
						function (elm) {
							return _.indexOf(elm.supportedConnectors, connectorType) != -1;
						}
					);
				} else {
					$scope.filteredreaderTypes = DepotUtils.initReaderTypes;
				}
				if (connectorType === 'HTTP') {
					$scope.depot.additional_params = $scope.depot.additional_params
						? $scope.depot.additional_params
						: {};
					$scope.depot.additional_params.iteration =
						$scope.depot.additional_params.iteration !== undefined
							? $scope.depot.additional_params.iteration
							: {};
					$scope.depot.additional_params.iteration.mode =
						$scope.depot.additional_params.iteration.mode !== undefined
							? $scope.depot.additional_params.iteration.mode
							: $scope.httpIterationModes[0].value;
				}
			};

			$scope.setSelectedCharset = function (autoCharset) {
				let connectorType =
					$scope.depot &&
					$scope.depot.connector &&
					$scope.depot.connector.connector_type
						? $scope.depot.connector.connector_type
						: undefined;
				$scope.selectedCharset =
					connectorType === 'S3' &&
					$scope.selectedCharset &&
					$scope.selectedCharset.value === 'DEFAULT'
						? undefined
						: $scope.selectedCharset;
				let found = false;
				for (let i in $scope.charsets) {
					if (
						$scope.depot &&
						$scope.depot.charset === $scope.charsets[i].value
					) {
						$scope.selectedCharset = $scope.charsets[i];
						found = true;
						break;
					}
				}
				if (
					(!found && autoCharset !== undefined) ||
					$scope.depot.charset === undefined
				) {
					if (autoCharset === undefined) {
						for (let i in $scope.charsets) {
							if ($scope.charsets[i].value === 'DEFAULT') {
								$scope.selectedCharset = $scope.charsets[i];
								break;
							}
						}
					}
				}
				$scope.depot.charset = $scope.selectedCharset.value;
			};

			$scope.refreshHeader = function () {
				if ($scope.depot.has_header == false) {
					$scope.depot.headers_referencing_mode =
						HEADER_REFERENCING_MODE_POSITION;
				}
			};

			$scope.filterEncodingAndReaders = function () {
				filterReaders();
				filterCharset();
				mergeHttpHeaders();
			};

			$scope.showConfirmationModal = function () {
				$('#confirmationModal').modal('show');
			};

			$scope.redirectionToList = redirectionToList;

			$scope.saveDepot = function () {
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted = $scope.save;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.save();
				}
			};

			$scope.detectionHeadersDepot = function () {
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showSyncHeadersConfirmationMessage;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showSyncHeadersConfirmationMessage();
				}
			};

			$scope.updatePositionHeadersDepot = function (index) {
				$scope.newHeader =
					index !== undefined ? $scope.headers[index].column : '';
				$scope.newHeaderType =
					index !== undefined ? $scope.headers[index].data_type : 'StringType';
				$scope.headerToUpdateIndex = index;
				$scope.buttonName =
					index !== undefined
						? gettextCatalog.getString('Enregistrer')
						: gettextCatalog.getString('Ajouter');
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showAddHeaderModal;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showAddHeaderModal();
				}
			};

			$scope.deleteHeadersDepot = function (index) {
				$scope.headerToUpdateIndex = index;
				$scope.headerLibToDel =
					$scope.headers != undefined && $scope.headers[index] != undefined
						? $scope.headers[index].column
						: '-';
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showDeleteHeaderModal;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showDeleteHeaderModal();
				}
			};

			$scope.deleteAllHeadersDepot = function () {
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showDeleteAllHeadersModal;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showDeleteAllHeadersModal();
				}
			};

			$scope.createExtractionDepot = function () {
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.createDepotExtraction;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.createDepotExtraction();
				}
			};

			$scope.createFilterExtractionDepot = function (filter) {
				$scope.filterValue = filter;
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showAddEditNewFilterModal;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showAddEditNewFilterModal();
				}
			};

			$scope.deleteFilterExtractionDepot = function (entity) {
				$scope.FilterTodeleteId = entity.id;
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showDeleteFilterConfirmationModal;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showDeleteFilterConfirmationModal();
				}
			};

			$scope.deleteExtractionDepot = function (entity) {
				$scope.archiveTodeleteId =
					entity.id != undefined ? entity.id : entity.date;
				if (!$scope.isNewDepot) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted =
						$scope.showDeleteArchiveConfirmationModal;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.showDeleteArchiveConfirmationModal();
				}
			};

			$scope.save = save;

			$scope.saveDbDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let dbDepot = {
					metadata: $scope.metadata,
					sql_query: $scope.depot.sql_query,
					code: $scope.metadata.code,
					headers: $scope.headers,
					connector_id: $scope.depot.connector.id,
				};

				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					DbSQLDepotService.createDbDepot(dbDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'SQL');
						})
						.catch(catchErrors);
				} else {
					DbSQLDepotService.editDbDepot($scope.depot.id, dbDepot)
						.then(function (response) {
							DepotUtils.notifyOnDataBaseDepotTypeEdit();
							if (returnToList) {
								$timeout(function () {
									$state.go('depots');
								}, 300);
							}
						})
						.catch(catchErrors);
				}
			};

			$scope.saveMongodbDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let mongodbDepot = angular.copy($scope.depot);
				delete mongodbDepot.delimiter_csv;
				delete mongodbDepot.quote_csv;
				delete mongodbDepot.has_header;
				delete mongodbDepot.auto_integration;
				delete mongodbDepot.replace_file;
				delete mongodbDepot.charset;
				delete mongodbDepot.depot_type;
				delete mongodbDepot.query;
				mongodbDepot.metadata = $scope.metadata;
				mongodbDepot.code = $scope.metadata.code;
				mongodbDepot.headers = $scope.headers;
				mongodbDepot.connector_id = mongodbDepot.connector.id;
				delete mongodbDepot.connector;
				delete mongodbDepot.id;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					MongodbDepotService.createMongodbDepot(mongodbDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'MONGODB');
						})
						.catch(catchErrors);
				} else {
					MongodbDepotService.editMongodbDepot($scope.depot.id, mongodbDepot)
						.then(function (response) {
							DepotUtils.notifyOnDataBaseDepotTypeEdit('MONGO_DB');
							if (returnToList) {
								$timeout(function () {
									$state.go('depots');
								}, 300);
							}
						})
						.catch(catchErrors);
				}
			};

			$scope.saveNeo4jDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let neo4JDepot = {
					metadata: $scope.metadata,
					query: $scope.depot.query,
					code: $scope.metadata.code,
					headers: $scope.headers,
					connector_id: $scope.depot.connector.id,
				};
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					Neo4jDepotService.createNeo4jDepot(neo4JDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'NEO4J');
						})
						.catch(catchErrors);
				} else {
					Neo4jDepotService.editNeo4jDepot($scope.depot.id, neo4JDepot)
						.then(function (response) {
							DepotUtils.notifyOnDataBaseDepotTypeEdit('NEO4J');
							if (returnToList) {
								$timeout(function () {
									$state.go('depots');
								}, 300);
							}
						})
						.catch(catchErrors);
				}
			};

			$scope.saveCsvDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let csvDepot = angular.copy($scope.depot);
				csvDepot.metadata = $scope.metadata;
				csvDepot.code = $scope.metadata.code;
				csvDepot.headers = $scope.headers;
				csvDepot.current_version_mask =
					csvDepot.current_version_mask != undefined
						? csvDepot.current_version_mask
						: '*.{csv,CSV,cSv,cSV,Csv,CSv,csV,CsV}';
				delete csvDepot.query;
				csvDepot.connector_id = csvDepot.connector.id;
				delete csvDepot.connector;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					CsvDepotService.createCsvDepot(csvDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'CSV');
						})
						.catch(catchErrors);
				} else {
					CsvDepotService.editCsvDepot($scope.depot.id, csvDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'CSV');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveParquetDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let parquetDepot = angular.copy($scope.depot);
				parquetDepot.metadata = $scope.metadata;
				parquetDepot.code = $scope.metadata.code;
				parquetDepot.headers = $scope.headers;
				parquetDepot.current_version_mask =
					parquetDepot.current_version_mask != undefined
						? parquetDepot.current_version_mask
						: '*.{parquet,PARQUET,Parquet}';
				delete parquetDepot.query;
				delete parquetDepot.charset;
				parquetDepot.connector_id = parquetDepot.connector.id;
				delete parquetDepot.connector;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					ParquetDepotService.createParquetDepot(parquetDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'PARQUET');
						})
						.catch(catchErrors);
				} else {
					ParquetDepotService.editParquetDepot($scope.depot.id, parquetDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'PARQUET');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveJsonDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let jsonDepot = angular.copy($scope.depot);
				jsonDepot.metadata = $scope.metadata;
				jsonDepot.code = $scope.metadata.code;
				jsonDepot.headers = $scope.headers;
				jsonDepot.current_version_mask =
					jsonDepot.current_version_mask != undefined
						? jsonDepot.current_version_mask
						: '*.{pdf,PDF,pDf,pDF,Pdf,PDf,pdF,PdF}';
				delete jsonDepot.query;
				jsonDepot.connector_id = jsonDepot.connector.id;
				delete jsonDepot.connector;
				delete jsonDepot.headers_referencing_mode;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					JsonDepotService.createJsonDepot(jsonDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'JSON');
						})
						.catch(catchErrors);
				} else {
					JsonDepotService.editJsonDepot($scope.depot.id, jsonDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'JSON');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveJsonV2Depot = function (returnToList, depotHeadersMapping) {
				let depotHeaders = angular.copy($scope.currentDepotSchema);
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let jsonDepot = angular.copy($scope.depot);
				jsonDepot.metadata = $scope.metadata;
				jsonDepot.code = $scope.metadata.code;
				jsonDepot.headers = $scope.headers;
				jsonDepot.current_version_mask =
					jsonDepot.current_version_mask != undefined
						? jsonDepot.current_version_mask
						: '*.{pdf,PDF,pDf,pDF,Pdf,PDf,pdF,PdF}';
				delete jsonDepot.query;
				jsonDepot.connector_id = jsonDepot.connector.id;
				delete jsonDepot.connector;
				delete jsonDepot.headers_referencing_mode;
				$scope.savingInProgress = true;

				jsonDepot.schema = depotHeaders;
				jsonDepot.type = 'JSON_V2';
				jsonDepot.json_line = $scope.depot.multiline;

				if ($scope.isNewDepot) {
					return RepositoryService.createRepository(jsonDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'JSON_V2');
						})
						.catch(catchErrors);
				} else {
					return RepositoryService.updateRepository(jsonDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'JSON_V2');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveExcelDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let excelDepot = angular.copy($scope.depot);
				excelDepot.metadata = $scope.metadata;
				excelDepot.code = $scope.metadata.code;
				excelDepot.headers = $scope.headers;
				delete excelDepot.query;
				delete excelDepot.charset;
				excelDepot.connector_id = excelDepot.connector.id;
				excelDepot.current_version_mask =
					excelDepot.current_version_mask != undefined
						? excelDepot.current_version_mask
						: '*.{xls,xlsx,XLS,xLs,xLS,Xls,XLs,xlS,XlS}';
				delete excelDepot.connector;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					ExcelDepotService.createExcelDepot(excelDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'EXCEL');
						})
						.catch(catchErrors);
				} else {
					ExcelDepotService.editExcelDepot($scope.depot.id, excelDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'EXCEL');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveBinaryDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}
				let binaryDepot = angular.copy($scope.depot);
				binaryDepot.metadata = $scope.metadata;
				binaryDepot.code = $scope.metadata.code;
				binaryDepot.headers = $scope.headers;
				binaryDepot.current_version_mask =
					binaryDepot.current_version_mask != undefined
						? binaryDepot.current_version_mask
						: '*.{json,JSON,Json,ndjson}';
				delete binaryDepot.query;
				delete binaryDepot.charset;
				binaryDepot.connector_id = binaryDepot.connector.id;
				delete binaryDepot.connector;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					BinaryDepotService.createBinaryDepot(binaryDepot).then(function (
						response
					) {
						createDepotSuccess(returnToList, response.data, 'BINARY');
					});
				} else {
					BinaryDepotService.editBinaryDepot($scope.depot.id, binaryDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'BINARY');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveXmlDepot = function (returnToList) {
				$('#confirmationModal').modal('hide');
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let xmlDepot = angular.copy($scope.depot);
				xmlDepot.metadata = $scope.metadata;
				xmlDepot.code = $scope.metadata.code;
				xmlDepot.headers = $scope.headers;
				xmlDepot.current_version_mask =
					xmlDepot.current_version_mask != undefined
						? xmlDepot.current_version_mask
						: '*.{xml,XML,Xml,XMl,xML,xmL,XmL}';
				delete xmlDepot.query;
				xmlDepot.connector_id = xmlDepot.connector.id;
				delete xmlDepot.connector;
				delete xmlDepot.headers_referencing_mode;
				$scope.savingInProgress = true;

				if ($scope.isNewDepot) {
					XmlDepotService.createXmlDepot(xmlDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'XML');
						})
						.catch(catchErrors);
				} else {
					XmlDepotService.editXmlDepot($scope.depot.id, xmlDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'XML');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveXmlV2Depot = function (returnToList, depotHeadersMapping) {
				if (depotHeadersMapping === null) {
					console.error('no headers mapping configured');
				}
				$('#confirmationModal').modal('hide');
				let depotHeaders = angular.copy($scope.currentDepotSchema);
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let xmlDepot = angular.copy($scope.depot);
				xmlDepot.metadata = $scope.metadata;
				xmlDepot.code = $scope.metadata.code;
				xmlDepot.headers = $scope.headers;
				xmlDepot.current_version_mask =
					xmlDepot.current_version_mask != undefined
						? xmlDepot.current_version_mask
						: '*.{xml,XML,Xml,XMl,xML,xmL,XmL}';
				delete xmlDepot.query;
				xmlDepot.connector_id = xmlDepot.connector.id;
				delete xmlDepot.connector;
				delete xmlDepot.headers_referencing_mode;
				$scope.savingInProgress = true;
				xmlDepot.schema = depotHeaders;
				xmlDepot.type = 'XML_V2';
				xmlDepot.row_tag = $scope.depot.new_line_tag;

				if ($scope.isNewDepot) {
					return RepositoryService.createRepository(xmlDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'XML_V2');
						})
						.catch(catchErrors);
				} else {
					return RepositoryService.updateRepository(xmlDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'XML_V2');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveTrinoDepot = function (returnToList, depotHeadersMapping) {
				if (depotHeadersMapping === null) {
					console.error('no headers mapping configured');
				}
				$('#confirmationModal').modal('hide');
				let depotHeaders = angular.copy($scope.currentDepotSchema);
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let trinoDepot = angular.copy($scope.depot);
				trinoDepot.metadata = $scope.metadata;
				trinoDepot.code = $scope.metadata.code;
				trinoDepot.headers = $scope.headers;
				trinoDepot.query = $scope.depot.query;
				trinoDepot.connector_id = trinoDepot.connector.id;
				$scope.savingInProgress = true;
				trinoDepot.schema = depotHeaders;
				trinoDepot.type = 'TRINO';

				if ($scope.isNewDepot) {
					return RepositoryService.createRepository(trinoDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'TRINO');
						})
						.catch(catchErrors);
				} else {
					return RepositoryService.updateRepository(trinoDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'TRINO');
						})
						.catch(catchErrors);
				}
			};

			$scope.saveSubscriptionDepot = function (
				returnToList,
				depotHeadersMapping
			) {
				if (depotHeadersMapping === null) {
					console.error('no headers mapping configured');
				}
				$('#confirmationModal').modal('hide');
				let depotHeaders = angular.copy($scope.currentDepotSchema);
				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color !== undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let subscriptionDepot = angular.copy($scope.depot);
				subscriptionDepot.metadata = $scope.metadata;
				subscriptionDepot.code = $scope.metadata.code;
				subscriptionDepot.headers = $scope.headers;
				$scope.savingInProgress = true;
				subscriptionDepot.schema = depotHeaders;
				subscriptionDepot.type = 'DATALINK';
				subscriptionDepot.row_tag = $scope.depot.new_line_tag;
				delete subscriptionDepot.connector;

				if ($scope.isNewDepot) {
					return RepositoryService.createRepository(subscriptionDepot)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, 'DATALINK');
						})
						.catch(catchErrors);
				} else {
					return RepositoryService.updateRepository(subscriptionDepot)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, 'DATALINK');
						})
						.catch(catchErrors);
				}
			};

			$scope.showLimitConfirmationModal = function () {
				$scope.sqlTestQuery = angular.copy($scope.depot.sql_query);
				$scope.checkPermissionData.elementId = $scope.depot.connector.id;
				$scope.checkPermissionData.type = 'connector';
				$scope.checkPermissionData.action = 'data';
				$scope.checkPermissionData.actionIfPermitted =
					$scope.doShowLimitConfirmationModal;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.doShowLimitConfirmationModal = function () {
				$scope.checkPermissionData.elementId = $scope.depot.connector.id;
				$scope.checkPermissionData.type = 'connector';
				$scope.checkPermissionData.action = 'data';
				$scope.checkPermissionData.actionIfPermitted = $scope.save;
				$scope.checkPermissionData.showPermissionCheck = true;
				$scope.sqlTestQuery = angular.copy($scope.depot.sql_query);
				$('#sqlLimitConfirmation').modal('show');
			};

			$scope.testQuery = function (modalId) {
				if (
					$scope.depot.connector == null ||
					$scope.depot.connector == undefined
				) {
					DepotUtils.notifyOnMissingConnector();
					return;
				}
				let data = {
					metadata: $scope.metadata,
					sql_query: $scope.sqlTestQuery,
					code: $scope.metadata.code,
					headers: $scope.headers,
					connector_id: $scope.depot.connector.id,
					id: $scope.depot.id,
				};
				$scope.jobError = {};
				$scope.jobError.mainPosition = false;
				DbSQLDepotService.getDbPreview(data, true)
					.then(function (response) {
						$('#sqlLimitConfirmation').modal('hide');
						$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
						$scope.entiteTypeFileDataPreview = response.data.data_preview;
						if (
							$scope.entiteTypeFileHeader == undefined ||
							$scope.entiteTypeFileDataPreview == undefined
						) {
							$scope.entiteTypeFileHeader = {};
							$scope.entiteTypeFileDataPreview = {};
							toaster.pop(
								'error',
								gettextCatalog.getString('Erreur'),
								gettextCatalog.getString('Echec du test')
							);
						} else {
							toaster.pop(
								'success',
								gettextCatalog.getString('Succès'),
								gettextCatalog.getString('Test Effectué')
							);
						}
						$scope.initGridData();
						$('#' + modalId).modal('show');
					})
					.catch(catchErrors);
			};

			$scope.testNeo4jQuery = function () {
				if (
					$scope.depot.connector == null ||
					$scope.depot.connector == undefined
				) {
					DepotUtils.notifyOnMissingConnector();
					return;
				}
				let data = {
					query: $scope.depot.query,
					connector_id: $scope.depot.connector.id,
					id: $scope.depot.id,
				};
				$scope.jobError = {};
				$scope.jobError.mainPosition = false;
				let modalId = 'dataPreviewModal';
				Neo4jDepotService.getNeo4jPreview(data, true)
					.then(function (response) {
						$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
						$scope.entiteTypeFileDataPreview = response.data.data_preview;
						if (
							$scope.entiteTypeFileHeader === undefined ||
							$scope.entiteTypeFileDataPreview === undefined
						) {
							$scope.entiteTypeFileHeader = {};
							$scope.entiteTypeFileDataPreview = {};
							toaster.pop(
								'error',
								gettextCatalog.getString('Erreur'),
								gettextCatalog.getString('Echec du test')
							);
						} else {
							toaster.pop(
								'success',
								gettextCatalog.getString('Succès'),
								gettextCatalog.getString('Test Effectué')
							);
						}
						$scope.initGridData();
						$('#' + modalId).modal('show');
					})
					.catch(catchErrors);
			};

			$scope.testTrinoQuery = function () {
				if (
					$scope.depot.connector == null ||
					$scope.depot.connector == undefined
				) {
					DepotUtils.notifyOnMissingConnector();
					return;
				}
				let data = {
					query: $scope.depot.query,
					connector_id: $scope.depot.connector.id,
					id: $scope.depot.id,
					type: 'TRINO',
					metadata: $scope.metadata,
				};
				$scope.jobError = {};
				$scope.jobError.mainPosition = false;
				let modalId = 'dataPreviewModal';
				RepositoryService.getQueryPreview(data)
					.then(function (response) {
						$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
						$scope.entiteTypeFileDataPreview = response.data.data_preview;
						if (
							$scope.entiteTypeFileHeader === undefined ||
							$scope.entiteTypeFileDataPreview === undefined
						) {
							$scope.entiteTypeFileHeader = {};
							$scope.entiteTypeFileDataPreview = {};
							toaster.pop(
								'error',
								gettextCatalog.getString('Erreur'),
								gettextCatalog.getString('Echec du test')
							);
						} else {
							toaster.pop(
								'success',
								gettextCatalog.getString('Succès'),
								gettextCatalog.getString('Test Effectué')
							);
						}
						$scope.initGridData();
						$('#' + modalId).modal('show');
					})
					.catch(catchErrors);
			};

			$scope.openDataPreviewer = function (file) {
				$scope.fileToView = file;
				if (
					$scope.depot.connector &&
					$scope.depot.connector.connector_type !== 'LOCAL'
				) {
					$scope.checkPermissionData.elementId = $scope.depot.connector.id;
					$scope.checkPermissionData.type = 'connector';
					$scope.checkPermissionData.action = 'data';
				} else if (
					$scope.depot.connector &&
					$scope.depot.connector.connector_type == 'LOCAL'
				) {
					$scope.checkPermissionData.elementId = $scope.depot.id;
					$scope.checkPermissionData.type = 'data_source';
					$scope.checkPermissionData.action = 'data';
				} else {
					$scope.doOpenDataPreviewer();
					return;
				}

				$scope.checkPermissionData.actionIfPermitted =
					$scope.doOpenDataPreviewer;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.downloadLocalFile = function (fileName, depotId, depotType) {
				AllDepotService.downloadLocalFile(fileName, depotId, depotType);
			};

			$scope.doOpenDataPreviewer = function () {
				let file = $scope.fileToView;
				let modalId = 'dataPreviewModal';
				$scope.isExtractionPreview = false;
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				if ($scope.depot.depot_type === 'BINARY') {
					$scope.binaryReady = false;
					DepotFileService.getRemoteBinaryFilePreview(
						$scope.depot.id,
						file.fileName,
						$scope.depot.depot_type
					)
						.then(function (response) {
							let type = response.headers('Content-Type');
							type = type !== undefined ? type : 'application/octet-stream';
							$scope.dataPdfTest = 'data:' + type + ';base64,' + response.data;
							$scope.dataResponseType = type;
							$('#' + modalId).modal('show');
							$scope.binaryReady = true;
						})
						.catch(catchErrors);
				} else if ($scope.depot.depot_type === 'MONGODB') {
					if (
						$scope.depot.connector === null ||
						$scope.depot.connector === undefined
					) {
						DepotUtils.notifyOnMissingConnector();
						return;
					}
					let data = angular.copy($scope.depot);
					data.connector_id = data.connector.id;
					delete data.connector;
					$scope.jobError = {};
					$scope.jobError.mainPosition = false;
					MongodbDepotService.getMongodbPreview(data, true)
						.then(function (response) {
							$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
							$scope.entiteTypeFileDataPreview = response.data.data_preview;
							$scope.initGridData();
							$('#' + modalId).modal('show');
						})
						.catch(catchErrors);
				} else if ($scope.depot.depot_type === 'NEO4J') {
					if (
						$scope.depot.connector === null ||
						$scope.depot.connector === undefined
					) {
						DepotUtils.notifyOnMissingConnector();
						return;
					}
					let data = angular.copy($scope.depot);
					data.connector_id = data.connector.id;
					delete data.connector;
					$scope.jobError = {};
					$scope.jobError.mainPosition = false;
					Neo4jDepotService.getNeo4jPreview(data, true)
						.then(function (response) {
							$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
							$scope.entiteTypeFileDataPreview = response.data.data_preview;
							$scope.initGridData();
							$('#' + modalId).modal('show');
						})
						.catch(catchErrors);
				} else {
					const depotType = $scope.depot.depot_type;

					let previewQuery;
					if (
						depotType.toLowerCase() === 'json_v2' ||
						depotType.toLowerCase() === 'xml_v2'
					) {
						previewQuery = RepositoryService.getRemoteFilePreview(
							$scope.depot.id,
							file.fileName
						);
					} else {
						previewQuery = DepotFileService.getRemoteFilePreview(
							$scope.depot.id,
							file.fileName,
							depotType
						);
					}
					previewQuery
						.then(function (response) {
							$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
							$scope.entiteTypeFileDataPreview = response.data.data_preview;
							$scope.initGridData();
							$('#' + modalId).modal('show');
						})
						.catch(catchErrors);
				}
				// TODO: add TIRNO
			};

			$scope.showExtractionPreview = function (Extraction) {
				$scope.extractionToView = Extraction;
				$scope.checkPermissionData.elementId = $scope.depot.id;
				$scope.checkPermissionData.type = 'data_source';
				$scope.checkPermissionData.action = 'data';
				$scope.checkPermissionData.actionIfPermitted =
					$scope.doShowExtractionPreview;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.doShowExtractionPreview = function () {
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				const depotType = $scope.depot.depot_type;

				let extractionPreviewQuery;
				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'xml_v2' ||
					depotType.toLowerCase() === 'datalink' ||
					depotType.toLowerCase() === 'trino'
				) {
					extractionPreviewQuery = RepositoryService.getExtractionPreview(
						$scope.depot.id,
						$scope.extractionToView.date
					);
				} else {
					extractionPreviewQuery = DepotExtractionService.getExtractionPreview(
						$scope.depot.id,
						$scope.extractionToView.date,
						depotType
					);
				}
				extractionPreviewQuery
					.then(function (response) {
						$scope.entiteTypeFileHeader = getHeaders(response.data.headers);
						$scope.entiteTypeFileDataPreview = response.data.data_preview;
						$scope.initGridData();
						$scope.isExtractionPreview = true;
						$('#dataPreviewModal').modal('show');
					})
					.catch(catchErrors);
			};

			$scope.initGridData = async function () {
				let resolveGridInstance = function () {
					if (Object.keys($scope.gridOptions).length === 0) {
						return;
					}
					return Promise.resolve($scope.gridOptions.onInitialized);
				};

				$scope.showDataPreviewGrid = false;
				$scope.gridData = [];
				$scope.gridOptions = {};
				let generatedColumns = [];
				//Create Grid Columns
				let headearsWithNoSpecChar = [];
				let localHeaders = _.filter($scope.headers, function (item) {
					return !item.depot_details;
				});
				for (let i = 0; i < $scope.entiteTypeFileHeader.length; i++) {
					let columnName = $scope.entiteTypeFileHeader[i];
					let columnDepName = '';
					if ($scope.depot.headers_referencing_mode === 'LABEL') {
						let locHeader = _.find(localHeaders, function (item) {
							return item.column == columnName;
						});
						columnDepName =
							locHeader && locHeader.column ? locHeader.column : '';
					} else {
						columnDepName =
							localHeaders[i] != undefined ? localHeaders[i].column : '';
					}
					let headerNoSpecChar = columnName
						.replace(/[^a-zA-Z0-9_-]/g, '_')
						.toLowerCase();
					headearsWithNoSpecChar[i] = headerNoSpecChar;
					if (i < 10) {
						$scope.moreThanTenColumns = false;
						generatedColumns.push({
							dataField: headerNoSpecChar,
							caption: '*' + columnDepName + ' / ' + columnName,
						});
					} else {
						$scope.moreThanTenColumns = true;
						generatedColumns.push({
							dataField: headerNoSpecChar,
							caption: '*' + columnDepName + ' / ' + columnName,
							visible: false,
						});
					}
				}
				//Load Data
				for (
					let count = 0;
					count < $scope.entiteTypeFileDataPreview.length;
					count++
				) {
					let object = $scope.gridData[count];
					let value = $scope.entiteTypeFileDataPreview[count];
					for (let l = 0; l < headearsWithNoSpecChar.length; l++) {
						let colName = headearsWithNoSpecChar[l];
						if (object == undefined) {
							object = {};
						}

						object[colName] = value[l];
						$scope.gridData[count] = object;
					}
				}
				$scope.gridOptions.pager = {
					showPageSizeSelector: true,
					allowedPageSizes: PAGINATIONS_SIZES,
					showInfo: true,
					visible: true,
				};
				$scope.gridOptions.paging = {
					enabled: true,
					pageSize: PAGINATIONS_SIZE,
				};
				$scope.gridOptions.filterRow = {
					visible: true,
					applyFilter: 'auto',
				};
				$scope.gridOptions.rowAlternationEnabled = true;
				$scope.gridOptions.headerFilter = {
					visible: true,
					applyFilter: 'auto',
				};
				$scope.gridOptions.columnChooser = {
					enabled: true,
				};
				$scope.gridOptions.onContentReady = function (e) {
					$scope.noColumnToChoose =
						e.component.getVisibleColumns().length === generatedColumns.length;
				};
				$scope.gridOptions.showColumnLines = true;
				$scope.gridOptions.showRowLines = true;
				$scope.gridOptions.allowColumnReordering = true;
				$scope.gridOptions.allowColumnResizing = true;
				$scope.gridOptions.columnAutoWidth = true;
				$scope.gridOptions.showBorders = true;
				$scope.gridOptions.onInitialized = function (e) {
					$scope.gridInstance = e.component;
				};
				$scope.gridOptions.dataSource = $scope.gridData;
				// Set a bigger z-index
				$(function () {
					DevExpress.ui.dxOverlay.baseZIndex(1999999998);
				});
				// Show Cell value in a popup
				$scope.gridOptions.onCellClick = function (e) {
					showValuePreviewOnCellDoubleClick(e, $scope.getShowValuePopup);
				};
				$scope.showDataPreviewGrid = true;
				await resolveGridInstance();
				if ($scope.gridInstance && $scope.gridInstance.option) {
					$scope.gridInstance.option('columns', generatedColumns);
					$scope.gridInstance.option('dataSource', $scope.gridData);
					$scope.gridInstance.refresh();
				}
			};

			$scope.getShowValuePopup = function (val) {
				$scope.previewModal.value = val;
				$scope.previewModal.showValuePreview = true;
			};

			$scope.showAddHeaderModal = function () {
				$('#showAddHeaderModal').modal('show');
			};

			$scope.addOrEditHeader = function (modalId) {
				if ($scope.headerToUpdateIndex !== undefined) {
					if ($scope.isNewDepot) {
						$scope.headers[$scope.headerToUpdateIndex].column =
							$scope.newHeader;
						$scope.headers[$scope.headerToUpdateIndex].data_type =
							$scope.newHeaderType;
						$('#' + modalId).modal('hide');
					} else {
						if (
							$scope.headers[$scope.headerToUpdateIndex] !== undefined &&
							$scope.headers[$scope.headerToUpdateIndex].id !== undefined
						) {
							let elm = angular.copy(
								$scope.headers[$scope.headerToUpdateIndex]
							);
							let headerId = elm.id;
							elm.column = $scope.newHeader;
							elm.data_type = $scope.newHeaderType;
							delete elm.id;
							DepotService.editHeader(
								headerId,
								elm,
								$scope.depot.depot_type
							).then(function (response) {
								$scope.headers[$scope.headerToUpdateIndex] = response.data;
								DepotUtils.notifyOnHeaderAction('edit', true);
								$('#' + modalId).modal('hide');
							});
						} else if (
							$scope.headers[$scope.headerToUpdateIndex].id == undefined
						) {
							$scope.saveFileHeadersPosition();
						}
					}
				} else {
					let header = {
						column: $scope.newHeader,
						position: $scope.headers.length,
						data_type: $scope.newHeaderType,
					};
					if ($scope.isNewDepot) {
						$scope.headers.push(header);
						$('#' + modalId).modal('hide');
					} else {
						DepotService.createHeader(
							$scope.depot.id,
							header,
							$scope.depot.depot_type
						).then(function (response) {
							$scope.headers = response.data;
							DepotUtils.notifyOnHeaderAction('add', true);
							$('#' + modalId).modal('hide');
						});
					}
				}
			};

			$scope.showDeleteHeaderModal = function () {
				$('#showDelHeaderModal').modal('show');
			};

			$scope.deleteHeader = function (modalId) {
				let elem = $scope.headers[$scope.headerToUpdateIndex];
				if (elem.id != undefined && elem.id != '') {
					if ($scope.depot.depot_type != 'BINARY') {
						DepotService.deleteHeader(elem.id, $scope.depot.depot_type).then(
							function (response) {
								$scope.headers.splice($scope.headerToUpdateIndex, 1);
								DepotUtils.notifyOnHeaderAction('delete', true);
								$('#' + modalId).modal('hide');
							}
						);
					}
				} else {
					$scope.headers.splice($scope.headerToUpdateIndex, 1);
					DepotUtils.notifyOnHeaderAction('update', true);
					$('#' + modalId).modal('hide');
				}
			};

			$scope.getHeaderRealType = function (type, list) {
				let realType = _.find($scope.dataTypes, function (elm) {
					return elm.value === type;
				});
				realType = realType !== undefined ? realType.label : type;
				return list
					? gettextCatalog.getString('Liste') + '(' + realType + ')'
					: realType;
			};

			$scope.uploadFileAndGetHeaders = function (files, event, flow) {
				flow.opts.query = {
					isDepot: true,
					code: $scope.metadata.code,
					depotType: $scope.depot.depot_type,
					charset: $scope.depot.charset,
				};

				flow.opts.headers = {
					'Accept-Language': $rootScope.currentLangCode,
					'x-xsrf-token': $cookies.get('XSRF-TOKEN'),
				};

				if ($scope.metadata.code == undefined || $scope.metadata.code == '') {
					MetadataService.getMatadataUniqueCode().then(function (response) {
						$scope.metadata.code = response.data;
						flow.upload();
						$scope.startSpin();
					});
				} else {
					flow.upload();
					$scope.startSpin();
				}
			};

			$scope.getHeadersFromResponse = function (flow, file, response) {
				let data = JSON.parse(response);
				$scope.createDepotHeaders(data, true);
				if (!$scope.isNewDepot) {
					$scope.headersReUploaded = false;
				}
			};

			$scope.handlUploadFileForHeaderError = function (response) {
				$scope.newFileUploaded = false;
				let data = JSON.parse(response);
				toaster.pop(
					'error',
					gettextCatalog.getString('Erreur'),
					data.message,
					20000
				);
			};

			$scope.createDepotHeaders = function (data, reuploaded) {
				if (data && data.length == 0) {
					toaster.pop(
						'error',
						gettextCatalog.getString('Erreur'),
						gettextCatalog.getString('Aucun entête trouvé')
					);
				}
				$scope.headers = [];
				for (let i in data) {
					const rootType = getRootType(data[i][1]);
					let header = {
						column: data[i][0],
						position: i,
						data_type: rootType,
						realDataType: gettextCatalog.getString(
							$scope.getHeaderRealType(rootType)
						),
					};
					$scope.headers.push(header);
				}
				$scope.headersReUploaded = reuploaded;
			};

			$scope.prepareHeaders = function () {
				for (let i in $scope.headers) {
					$scope.headers[i].position = i;
				}
			};

			$scope.saveFileHeadersPosition = function (fromCreate) {
				if (!fromCreate) {
					createMetadataHeader($scope.headers);
				}

				if ($scope.REPOSITORY_V2_TYPES.includes($scope.depot.depot_type)) {
					return;
				}

				for (let i in $scope.headers) {
					$scope.headers[i].position = i;
				}
				const depotType = $scope.depot.depot_type;

				DepotService.updateAllHeadersPositions(
					$scope.depot.id,
					$scope.headers,
					$scope.headersReUploaded,
					depotType
				).then(function () {
					DepotService.getHeadersByDepotId($scope.depot.id, depotType).then(
						function (response) {
							$scope.headers = response.data;
							$scope.headersReUploaded = false;
							DepotUtils.notifyOnHeaderAction('update', true);
						}
					);
				});
			};

			$scope.showDeleteAllHeadersModal = function () {
				$('#deleteAllheadersModal').modal('show');
			};

			$scope.deleteAllHeaders = function (modalId) {
				if ($scope.depot.id != undefined) {
					const depotType = $scope.depot.depot_type;

					let query;
					if (
						depotType.toLowerCase() === 'json_v2' ||
						depotType.toLowerCase() === 'xml_v2' ||
						depotType.toLowerCase() === 'datalink' ||
						depotType.toLowerCase() === 'trino'
					) {
						query = RepositoryService.deleteAllHeaders($scope.depot.id);
					} else {
						query = DepotService.deleteAllHeaders($scope.depot.id, depotType);
					}

					query.then(function () {
						let headersQuery;
						if (
							depotType.toLowerCase() === 'json_v2' ||
							depotType.toLowerCase() === 'xml_v2' ||
							depotType.toLowerCase() === 'datalink' ||
							depotType.toLowerCase() === 'trino'
						) {
							headersQuery = RepositoryService.getHeadersByRepositoryId(
								$scope.depot.id
							);
						} else {
							headersQuery = DepotService.getHeadersByDepotId(
								$scope.depot.id,
								depotType
							);
						}

						headersQuery.then(function (response) {
							$scope.headers = response.data;
							DepotUtils.notifyOnDeleteHeadersSuccess();
							$('#' + modalId).modal('hide');
						});
					});
				} else {
					$scope.headers = [];
					DepotUtils.notifyOnDeleteHeadersSuccess();
					$('#' + modalId).modal('hide');
				}
			};

			$scope.submitFlow = function (files, event, flow) {
				$scope.errorMessageCounter = 0;
				if ($scope.metadata.code == undefined || $scope.metadata.code == '') {
					MetadataService.getMatadataUniqueCode().then(function (response) {
						$scope.metadata.code = response.data;
						$scope.uploadFile(flow);
					});
				} else {
					$scope.uploadFile(flow);
				}
			};

			$scope.uploadFile = function (flow) {
				$scope.HeadersFormUploadedFile =
					$scope.isNewDepot && $scope.headers.length == 0;
				$scope.currentFlow = flow;
				$scope.isUpload = true;
				handleUpload();
			};

			$scope.resume = function (flow, file) {
				$scope.HeadersFormUploadedFile =
					$scope.isNewDepot && $scope.headers.length == 0;
				$scope.currentFlow = flow;
				$scope.currentUploadFile = file;
				$scope.isUpload = false;
				let replaceFiles = $scope.getShowReplaceConfirmation(flow.files);
				if (replaceFiles) {
					$('#replaceFileConfirmation').modal('show');
				} else {
					resumeUpload($scope.depot.replace_file);
				}
			};

			$scope.setSaveButtonDisabledAndGetHeaders = function (
				flow,
				file,
				response
			) {
				let data = JSON.parse(response);
				$scope.uploadedFileProcessingDone[file.uniqueIdentifier] = true;
				$scope.filesWithHeadersCheck =
					$scope.depot.depot_type == 'CSV' ? data.depot_files : data.v2;
				$scope.initFilesGrid();
				$scope.newFileUploaded = true;
				$scope.showDataPreview = true;
				$scope.depot.original_name =
					$scope.depot.depot_type == 'CSV'
						? data.original_name
						: data.v1
						? data.v1.v3
						: undefined;
				$scope.depot.isTemp = data.is_temp;
				$scope.disableMetaDataCode = true;
				$scope.fileNamesMapper[$scope.depot.original_name] =
					$scope.depot.depot_type == 'CSV'
						? data.file_name
						: data.v1
						? data.v1.v2
						: undefined;

				// Get Remote files
				if (!$scope.isNewDepot) {
					$scope.getDepotRemoteFiles();
				}

				if ($scope.HeadersFormUploadedFile) {
					$scope.createDepotHeaders(data.file_headers, false);
				}

				$scope.atLeastOneFileUploaded = true;
				$scope.oldDepotType = angular.copy($scope.depot.depot_type);
			};

			$scope.uploadError = function (file, response, flow) {
				let data = JSON.parse(response);
				if (data.code == '34') {
					toaster.pop('warning', data.message);
					flow.cancel();
					return;
				}
				let error =
					data.field_errors != undefined && data.field_errors.length > 0
						? data.field_errors[0]
						: data;
				if (error.field != undefined) {
					angular.forEach($scope.files.flow.files, function (flowUnit) {
						flowUnit.cancel();
					});
				}
				toaster.pop('error', '', error.message, 20000);
				if (error.element != undefined) {
					$scope.fileNamesMapper[file.name] = error.element;
				}
			};

			$scope.initFilesGrid = function () {
				$scope.filesData = [];
				$scope.isExecutionFilesReady = false;
				if ($scope.filesWithHeadersCheck != undefined) {
					angular.forEach($scope.filesWithHeadersCheck, function (value) {
						$scope.filesData.push({
							fileName: value.name,
							isTemp: value.temp,
							code: value.code,
							isPending: false,
							displayName: value.display_name,
							creationDate: $filter('date')(
								value.creation_date,
								DATE_TIME_PATTERN
							),
						});
					});
				}
				$scope.loadFilesData = $scope.filesData;
				$scope.filesGridOptions.dataSource = $scope.loadFilesData;
				$scope.isExecutionFilesReady = true;
				if ($scope.filesGridInstance && $scope.filesGridInstance.refresh) {
					$scope.filesGridInstance.option('dataSource', $scope.loadFilesData);
					$scope.filesGridInstance.refresh();
				}
			};

			$scope.initArchivesGrid = function () {
				$scope.isArchiveReady = false;
				$scope.archivesData = [];
				if ($scope.archives != undefined) {
					angular.forEach($scope.archives, function (value) {
						$scope.archivesData.push({
							date: value,
							displayName: decodeURIComponent(value),
						});
					});

					$scope.archivesDataGridOptions.dataSource = $scope.archivesData;
					$scope.isArchiveReady = true;
					if (
						$scope.gridArchivesInstance &&
						$scope.gridArchivesInstance.refresh
					) {
						$scope.gridArchivesInstance.option(
							'dataSource',
							$scope.archivesData
						);
						$scope.gridArchivesInstance.refresh();
					}
				}
			};

			$scope.initRemoteFilesGrid = function () {
				$scope.remotFiles = [];
				$scope.isRemoteFilesReady = false;
				if (
					$scope.filesWithHeadersCheck != undefined ||
					($scope.depot &&
						$scope.depot.connector &&
						($scope.depot.connector.connector_type == 'SFTP' ||
							$scope.depot.connector.connector_type == 'FTP' ||
							$scope.depot.connector.connector_type == 'S3' ||
							$scope.depot.connector.connector_type == 'HDFS' ||
							$scope.depot.connector.connector_type == 'LOCAL'))
				) {
					angular.forEach($scope.remotefiles, function (value) {
						$scope.remotFiles.push({
							fileName: value.name,
							displayName:
								value.display_name != undefined
									? value.display_name
									: value.name,
							remote: true,
							hdfs:
								$scope.depot.connector.connector_type == 'HDFS' ||
								$scope.depot.connector.connector_type == 'LOCAL',
							isTemp: value.temp || value.isTemp,
							creationDate: $filter('date')(
								value.creation_date,
								DATE_TIME_PATTERN
							),
						});
					});
				}
				$scope.loadremotefilesData = $scope.remotFiles;
				$scope.remoteFilesGridOptions.dataSource = $scope.loadremotefilesData;
				$scope.isRemoteFilesReady = true;
				if (
					$scope.remoteFilesGridInstance &&
					$scope.remoteFilesGridInstance.refresh
				) {
					$scope.remoteFilesGridInstance.option(
						'dataSource',
						$scope.loadremotefilesData
					);
					$scope.remoteFilesGridInstance.refresh();
				}
			};

			$scope.showDeleteFileByNameConfirmationModal = function (
				modalId,
				node,
				file
			) {
				$scope.depotFileToDelete = {
					name: node.fileName,
					temp: node.isTemp,
					code: $scope.depot.metadata.code,
					depot_type: $scope.depot.depot_type,
					deleteFromFlow: node.deleteFromFlow,
					originalName: node.originalName,
				};

				if ($scope.depot && $scope.depot.id != undefined) {
					$scope.fileToDeleteByNameId = $scope.depot.id;
					EntiteDepotService.getUetByDepotId(
						$scope.fileToDeleteByNameId,
						true
					).then(function (response) {
						$scope.linkedEntitites = response.data;
					});
				}
				$('#' + modalId).modal('show');
				$scope.fileFlowToCancel = file;
			};

			$scope.delByNameConfirmation = function (delModal) {
				if ($scope.depotFileToDelete.temp) {
					$scope.deleteFileByName(delModal, false);
				} else {
					$scope.deleteFileByName(delModal);
				}
			};

			$scope.deleteFileByName = function (modalId) {
				if (
					$scope.depot.connector.connector_type == 'HDFS' ||
					$scope.depot.connector.connector_type == 'LOCAL'
				) {
					$scope.depotFileToDelete.connector_id = $scope.depot.connector.id;
					$scope.depotFileToDelete.depot_path = $scope.depot.path;
					$scope.jobError = {};
					$scope.jobError.mainPosition = true;

					const depotType = $scope.depot.depot_type;

					let deleteQuery;
					if (
						depotType.toLowerCase() === 'json_v2' ||
						depotType.toLowerCase() === 'xml_v2'
					) {
						deleteQuery = RepositoryService.deleteFileByName(
							$scope.depot.id,
							$scope.depotFileToDelete
						);
					} else {
						deleteQuery = DepotFileService.deleteFileByName(
							$scope.depotFileToDelete,
							$scope.depot.id,
							depotType
						);
					}

					deleteQuery
						.then(function (response) {
							DepotUtils.notifyOnDeleteFile(true);
							$scope.getDepotRemoteFiles();
						})
						.catch(catchErrors);
				} else {
					DepotUtils.notifyOnDeleteFile(false);
				}
				$('#' + modalId).modal('hide');
			};

			$scope.getLinkedEntiteTypes = function () {
				$scope.showTable = true;
			};

			$scope.showDeleteEntiteTypeModal = function (modalId, linkId) {
				$scope.entiteTypeToDeleteId = linkId;
				$('#' + modalId).modal('show');
			};

			$scope.deleteEntiteTypeFileMapping = function (modalId) {
				EntiteDepotService.deleteEntiteTypeDepotLink(
					$scope.entiteTypeToDeleteId
				).then(function () {
					DepotUtils.notifyOnDeleteEntityFileMapping();
					$scope.getLinkedEntiteTypes();
					$('#' + modalId).modal('hide');
				});
			};

			$scope.createDepotExtraction = function () {
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				const depotType = $scope.depot.depot_type;

				let extractionQuery;
				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'xml_v2' ||
					depotType.toLowerCase() === 'trino' ||
					depotType.toLowerCase() === 'datalink'
				) {
					extractionQuery = RepositoryService.createExtractionByRepositoryId(
						$scope.depot.id
					);
				} else {
					extractionQuery = DepotExtractionService.createExtraction(
						$scope.depot.id,
						depotType
					);
				}

				extractionQuery
					.then(function (response) {
						$scope.getExtractions();
						DepotUtils.notifyOnCreateDepotExtraction();
					})
					.catch(catchErrors);
			};

			$scope.getExtractions = function () {
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				const depotType = $scope.depot.depot_type;

				let extractionQuery;
				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'xml_v2' ||
					depotType.toLowerCase() === 'trino' ||
					depotType.toLowerCase() === 'datalink'
				) {
					extractionQuery = RepositoryService.getExtractionsByRepositoryId(
						$scope.depot.id
					);
				} else {
					extractionQuery = DepotExtractionService.getExtractions(
						$scope.depot.id,
						depotType
					);
				}
				extractionQuery
					.then(function (response) {
						$scope.archives = response.data;
						$scope.initArchivesGrid();
					})
					.catch(catchErrors);
			};

			$scope.initFiltersGrid = function () {
				$scope.isFiltersReady = false;
				$scope.loadFiltersData = $scope.filters;
				$scope.filtersDataGridOptions.dataSource = $scope.filters;
				$scope.isFiltersReady = true;
			};

			$scope.getFilters = function () {
				const depotType = $scope.depot.depot_type;

				let filtersQuery;
				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'xml_v2' ||
					depotType.toLowerCase() === 'trino' ||
					depotType.toLowerCase() === 'datalink'
				) {
					filtersQuery = RepositoryService.getFiltersByRepositoryId(
						$scope.depot.id
					);
				} else {
					filtersQuery = DepotExtractionFilterService.findAllExtractionsFilters(
						$scope.depot.id,
						depotType
					);
				}

				filtersQuery.then(function (response) {
					$scope.filters = response.data;
					$scope.initFiltersGrid();
				});
			};

			$scope.showDeleteFilterConfirmationModal = function () {
				$('#delFilterModal').modal('show');
			};

			$scope.deleteFilter = function () {
				const depotType = $scope.depot.depot_type;
				let deleteFilterQuery;

				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'datalink' ||
					depotType.toLowerCase() === 'trino' ||
					depotType.toLowerCase() === 'xml_v2'
				) {
					deleteFilterQuery = RepositoryService.deleteFilterById(
						$scope.FilterTodeleteId
					);
				} else {
					deleteFilterQuery =
						DepotExtractionFilterService.deleteExtractionFilter(
							$scope.FilterTodeleteId,
							depotType
						);
				}
				deleteFilterQuery.then(function (response) {
					for (let i in $scope.filters) {
						if (response.data == $scope.filters[i].id) {
							$scope.filters.splice(i, 1);
							break;
						}
					}
					DepotUtils.notifyOnDeleteFilter(true);
					$scope.initFiltersGrid();
					$scope.gridFilterExtractionInstance.refresh();
					$('#delFilterModal').modal('hide');
				});
			};

			$scope.showDeleteArchiveConfirmationModal = function () {
				$('#delArchiveModal').modal('show');
			};

			$scope.deleteDepotExtraction = function (modalId) {
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				const depotType = $scope.depot.depot_type;

				let extractionDeleteQuery;
				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'datalink' ||
					depotType.toLowerCase() === 'trino' ||
					depotType.toLowerCase() === 'xml_v2'
				) {
					extractionDeleteQuery = RepositoryService.deleteRepoExtraction(
						$scope.depot.id,
						$scope.archiveTodeleteId
					);
				} else {
					extractionDeleteQuery = DepotExtractionService.deleteExtraction(
						$scope.depot.id,
						$scope.archiveTodeleteId,
						depotType
					);
				}

				extractionDeleteQuery
					.then(function (response) {
						$scope.getExtractions();
						DepotUtils.notifyOnDeleteExtraction(true);
						$('#' + modalId).modal('hide');
					})
					.catch(catchErrors);
			};

			$scope.showClearFolderConfirmation = function (modalId, type) {
				$scope.clearFolderName =
					type == 'execution'
						? gettextCatalog.getString('Exécution')
						: type == 'panding'
						? gettextCatalog.getString('En attente')
						: type == 'rejected'
						? gettextCatalog.getString('Fichiers rejetés')
						: gettextCatalog.getString('Archives');
				$scope.clearFolderType = type;
				$('#' + modalId).modal('show');
			};

			$scope.getDepotRemoteFiles = function () {
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				let remoteFilesQuery;
				const depotType = $scope.depot.depot_type;
				if (
					depotType.toLowerCase() === 'json_v2' ||
					depotType.toLowerCase() === 'xml_v2'
				) {
					remoteFilesQuery = RepositoryService.getRemoteFilesByRepositoryId(
						$scope.depot.id,
						$scope.depot.path,
						$scope.depot.current_version_mask,
						$scope.depot.fetched_files_limit
					);
				} else {
					remoteFilesQuery = DepotFileService.getDepotRemoteFiles(
						$scope.depot.id,
						$scope.depot.path,
						$scope.depot.current_version_mask,
						$scope.depot.depot_type,
						$scope.depot.fetched_files_limit
					);
				}
				remoteFilesQuery
					.then(function (response) {
						$scope.remotefiles = response.data;
						$scope.initRemoteFilesGrid();
					})
					.catch(catchErrors);
			};

			$scope.showSyncHeadersConfirmationMessage = function () {
				if ($scope.headers == undefined || $scope.headers.length == 0) {
					$scope.getHeadersFromDepot('syncHeadersConfirmation');
				} else {
					$('#syncHeadersConfirmation').modal('show');
				}
			};

			$scope.getHeadersFromDepot = function (modalId) {
				let depot = angular.copy($scope.depot);
				depot.metadata = $scope.metadata;
				$scope.headersReUploaded = true;
				depot.connector_id =
					depot.connector != undefined ? depot.connector.id : depot.connectorId;
				delete depot.connector;
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				DepotService.getHeadersFromDepot(depot, true, $scope.depot.depot_type)
					.then(function (response) {
						$scope.createDepotHeaders(response.data, true);
					})
					.catch(catchErrors);
				$('#' + modalId).modal('hide');
			};

			// Etat de lecture d'un depot DATALINK, tel que le backend le calcule
			// (DataLinkDCRepositoryStatus). AVAILABLE ne dit rien : le depot lit
			// ce qu'il doit lire. Les autres expliquent pourquoi il ne lit rien,
			// et le niveau dit si la situation se repare seule.
			const DATALINK_STATUS_NOTICES = {
				WAITING_PRODUCER: {
					level: 'info',
					key: 'depot.datalink.status.waiting.producer',
				},
				WAITING_AUTHORIZATION: {
					level: 'info',
					key: 'depot.datalink.status.waiting.authorization',
				},
				PRODUCER_UNAVAILABLE: {
					level: 'info',
					key: 'depot.datalink.status.producer.unavailable',
				},
				UNPUBLISHED: {
					level: 'info',
					key: 'depot.datalink.status.unpublished',
				},
				SUSPENDED: {
					level: 'warning',
					key: 'depot.datalink.status.suspended',
				},
				FAILED: {
					level: 'warning',
					key: 'depot.datalink.status.failed',
				},
				NOT_LINKED: {
					level: 'warning',
					key: 'depot.datalink.status.not.linked',
				},
				REVOKED: {
					level: 'error',
					key: 'depot.datalink.status.revoked',
				},
				DELETED: {
					level: 'error',
					key: 'depot.datalink.status.deleted',
				},
			};

			function setDataLinkStatusNotice() {
				const notice =
					$scope.depot != undefined
						? DATALINK_STATUS_NOTICES[$scope.depot.status]
						: undefined;
				$scope.dataLinkStatusNotice = notice
					? {
							level: notice.level,
							message: gettextCatalog.getString(notice.key),
					  }
					: undefined;
			}

			$scope.openChangeVersionModal = function () {
				let depot = angular.copy($scope.depot);
				NgDepot.openChangeVersionModal({
					id: depot.id,
					dataLinkLabel: depot.data_link_label,
					currentVersion: `V ${depot.source_project_version}`,
					headers: depot.headers
						.filter((header) => header.depot_details !== true)
						.map((header) => ({
							id: header.column_in_schema_id,
							label: header.column,
							type: header.data_type,
							isList: header.list,
						})),
				});
			};

			// Ecrire aux responsables du DataLink lu par ce depot : la popup et
			// l'envoi vivent cote Angular, l'ecran ne fournit que l'identifiant.
			$scope.openSendEmailPopup = function () {
				NgDepot.openSendEmailPopup($scope.depot.id);
			};

			$scope.showAddEditNewFilterModal = function () {
				let filter = $scope.filterValue;
				$scope.isNewFilter = filter == undefined;
				$scope.buttonName = $scope.isNewFilter
					? gettextCatalog.getString('Ajouter')
					: gettextCatalog.getString('Enregistrer');
				$scope.filter = $scope.isNewFilter ? {} : angular.copy(filter);
				$scope.filter.first_date_value = $rootScope.getDateWithPattern(
					$scope.filter.first_date_value
				);
				$scope.filter.second_date_value = $rootScope.getDateWithPattern(
					$scope.filter.second_date_value
				);
				$('#addEditFilterModal').modal('show');
			};

			$scope.addOrEditFilter = function () {
				const depotType = $scope.depot.depot_type;
				if ($scope.isNewFilter) {
					let createFilterQuery;
					if (
						depotType.toLowerCase() === 'json_v2' ||
						depotType.toLowerCase() === 'xml_v2' ||
						depotType.toLowerCase() === 'datalink' ||
						depotType.toLowerCase() === 'trino'
					) {
						createFilterQuery = RepositoryService.createFilter(
							$scope.depot.id,
							$scope.filter
						);
					} else {
						createFilterQuery =
							DepotExtractionFilterService.createExtractionFilter(
								$scope.depot.id,
								$scope.filter,
								depotType
							);
					}
					createFilterQuery.then(function (resp) {
						$scope.filters.unshift(resp.data);
						DepotUtils.notifyOnAddEditFilter();
						$scope.initFiltersGrid();
						$('#addEditFilterModal').modal('hide');
						$scope.gridFilterExtractionInstance.refresh();
					});
				} else {
					let filterToEdit = angular.copy($scope.filter);
					delete filterToEdit.id;
					let editFilterQuery;

					if (
						depotType.toLowerCase() === 'json_v2' ||
						depotType.toLowerCase() === 'xml_v2' ||
						depotType.toLowerCase() === 'datalink' ||
						depotType.toLowerCase() === 'trino'
					) {
						editFilterQuery = RepositoryService.updateFilterById(
							$scope.filter.id,
							filterToEdit
						);
					} else {
						editFilterQuery = DepotExtractionFilterService.editExtractionFilter(
							$scope.filter.id,
							filterToEdit,
							depotType
						);
					}

					editFilterQuery.then(function (resp) {
						for (let i in $scope.filters) {
							if ($scope.filters[i].id == resp.data.id) {
								$scope.filters[i] = resp.data;
								break;
							}
						}
						$scope.initFiltersGrid();
						DepotUtils.notifyOnAddEditFilter();
						$('#addEditFilterModal').modal('hide');
						$scope.gridFilterExtractionInstance.refresh();
					});
				}
			};

			$scope.showDeleteModal = function () {
				$scope.objToDelete = angular.copy($scope.depot);
				$scope.checkPermissionData.elementId = $scope.objToDelete.id;
				$scope.checkPermissionData.type = 'data_source';
				$scope.checkPermissionData.action = 'delete';
				$scope.checkPermissionData.actionIfPermitted = $scope.doShowDeleteModal;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.doShowDeleteModal = function () {
				$scope.deleteElementData = {
					label: $scope.objToDelete.metadata
						? $scope.objToDelete.metadata.label
						: '',
					doDelete: $scope.deleteDepot,
					showConfirmDeleteElement: true,
					bulk: false,
				};
			};

			$scope.deleteDepot = function () {
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				if ($scope.objToDelete.depot_type === 'SQL') {
					DbSQLDepotService.deleteDbDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('SQL');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'MONGODB') {
					MongodbDepotService.deleteMongodbDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('MONGODB');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'NEO4J') {
					Neo4jDepotService.deleteNeo4jDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('NEO4J');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'CSV') {
					CsvDepotService.deleteCsvDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('CSV');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'PARQUET') {
					ParquetDepotService.deleteParquetDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('PARQUET');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'JSON') {
					JsonDepotService.deleteJsonDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('JSON');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'BINARY') {
					BinaryDepotService.deleteBinaryDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('BINARY');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'EXCEL') {
					ExcelDepotService.deleteExcelDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('EXCEL');
						})
						.catch(catchErrors);
				} else if ($scope.objToDelete.depot_type === 'XML') {
					XmlDepotService.deleteXmlDepot($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot('XML');
						})
						.catch(catchErrors);
				} else if (
					$scope.REPOSITORY_V2_TYPES.includes($scope.objToDelete.depot_type)
				) {
					RepositoryService.deleteRepository($scope.objToDelete.id)
						.then(function () {
							actionsAfterDeleteDepot($scope.objToDelete.depot_type);
						})
						.catch(catchErrors);
				}
			};

			$scope.showHdhGraph = function () {
				$scope.elementGraphData.centeredElementLabel =
					$scope.depot.metadata.label;
				$scope.elementGraphData.centeredElementType = 'DEPOT';
				$scope.elementGraphData.centeredElementId = $scope.depot.id;
				$scope.elementGraphData.showHdhElementGraph = true;
			};

			$scope.doShowPermissions = function () {
				$scope.permissionData.metadataId = $scope.depot.metadata.id;
				$scope.permissionData.type = 'data_source';
				$scope.permissionData.elementId = $scope.depot.id;
				$scope.permissionData.lib = $scope.depot.metadata.label;
				$scope.permissionData.showElementPermissions = true;
			};

			$scope.showPermissions = function () {
				$scope.checkPermissionData.elementId = $scope.depot.id;
				$scope.checkPermissionData.type = 'data_source';
				$scope.checkPermissionData.action = 'permissions';
				$scope.checkPermissionData.actionIfPermitted = $scope.doShowPermissions;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.getRealDbType = function (type) {
				switch (type) {
					case 'mariaDb':
						return 'MariaDB';
					case 'mySql':
						return 'MySQL';
					case 'oracle':
						return 'Oracle';
					case 'pgSql':
						return 'PostgreSQL';
					case 'sqlServer':
						return 'SQL Server';
					case 'mongoDb':
						return 'MongoDB';
					case 'neo4j':
						return 'Neo4j';
					case 'trino':
						return 'Trino';
					default:
						return type;
				}
			};

			$scope.getRealConnectorType = function (type) {
				switch (type) {
					case 'SQL':
						return ' (Bdd)';
					case 'HTTP':
						return ' (HTTP)';
					case 'S3':
						return ' (S3 / MinIO)';
					case 'SFTP':
						return ' (SFTP)';
					case 'FTP':
						return ' (FTP)';
					case 'HDFS':
						return ' (HDFS)';
					case 'HTTP':
						return ' (HTTP)';
					default:
						return type;
				}
			};

			$scope.$watch('headers', function (newValue, oldValue) {
				if (
					newValue &&
					oldValue &&
					!_.isEqual(_.omit(newValue, 'position'), _.omit(oldValue, 'position'))
				) {
					createMetadataHeader(newValue);
				}
			});

			$scope.copyToClipboard = function (e) {
				let $temp_input = $('<input>');
				$('body').append($temp_input);
				$temp_input.val(e).select();
				document.execCommand('copy');
				$temp_input.remove();
				if ($scope.readingMaskCopy) {
					$scope.depot.current_version_mask = e != undefined ? e.trim() : e;
					$scope.readingMaskCopy = false;
					$('#currentVersionMAskSuggestions').modal('hide');
				} else if ($scope.sepValueCopy) {
					$scope.depot.delimiter_csv = e != undefined ? e.trim() : e;
					$scope.sepValueCopy = false;
					$('#sepSuggestions').modal('hide');
				}
			};

			$scope.showPossibleValuesVersionMask = function (modalId) {
				$scope.readingMaskCopy = true;
				$('#' + modalId).modal('show');
			};

			$scope.showDataAddressHelp = function (modalId) {
				$('#' + modalId).modal('show');
			};

			$scope.showPossibleSepValues = function (modalId) {
				$scope.sepValueCopy = true;
				$('#' + modalId).modal('show');
			};

			$scope.setDefaultFetchedFiles = function () {
				$scope.depot.fetched_files_limit =
					$scope.depot.fetched_files_limit == undefined ||
					$scope.depot.fetched_files_limit == ''
						? $scope.limitDisplayedFiles[0]
						: $scope.depot.fetched_files_limit;
			};

			$scope.addHeaderValue = function () {
				$scope.depot.additional_params =
					$scope.depot.additional_params != undefined
						? $scope.depot.additional_params
						: {};
				$scope.depot.additional_params.headers =
					$scope.depot.additional_params.headers != undefined
						? $scope.depot.additional_params.headers
						: {};
				let length = Object.keys($scope.httpHeadersInheritance).length;
				$scope.depot.additional_params.headers['key' + length] =
					'value' + length;

				$scope.httpHeadersInheritance.push({
					key: 'key' + length,
					value: 'value' + length,
					isInherited: false,
				});
			};

			$scope.deleteHeaderValue = function (index) {
				let isInherited = $scope.httpHeadersInheritance[index].isInherited;
				if (!isInherited) {
					let keyToDelete = $scope.httpHeadersInheritance[index].key;
					deleteDepotParamHeader(keyToDelete);
				}
				$scope.httpHeadersInheritance.splice(index, 1);
			};

			function deleteDepotParamHeader(key) {
				let depotKeys = Object.keys($scope.depot.additional_params.headers);
				for (let oldKey of depotKeys) {
					if (oldKey === key) {
						delete $scope.depot.additional_params.headers[oldKey];
						break;
					}
				}
			}

			$scope.updateHeaderKey = function (header, index) {
				let isValueDuplicated = false;
				for (let oldHeaderIndex in $scope.httpHeadersInheritance) {
					if (
						$scope.httpHeadersInheritance[oldHeaderIndex].key == header.key &&
						oldHeaderIndex != index
					) {
						$scope.httpHeadersInheritance[oldHeaderIndex].value = header.value;
						isValueDuplicated = true;
					}
				}
				// If the key already exists, the new value will overwrite the value of the existing key
				// If the key doesn't exist yet, then this header is not herited
				if (isValueDuplicated) {
					$scope.httpHeadersInheritance.splice(index, 1);
				} else {
					header.isInherited = false;
				}
				// Regenerate depot http headers
				$scope.depot.additional_params.headers = {};
				for (let i in $scope.httpHeadersInheritance) {
					if (
						!(
							$scope.httpHeadersInheritance[i].isInherited &&
							$scope.httpHeadersInheritance[i].value == ''
						)
					) {
						$scope.depot.additional_params.headers[
							$scope.httpHeadersInheritance[i].key
						] = $scope.httpHeadersInheritance[i].value;
					}
				}
			};

			$scope.updateHeaderValue = function (header, index) {
				// If header is herited and its value is empty, delete it from the depot params
				if (header.isInherited && header.value == '') {
					deleteDepotParamHeader(header.key);
				} else {
					// Depot params might not be initialized if all headers are inherited
					$scope.depot.additional_params =
						$scope.depot.additional_params != undefined
							? $scope.depot.additional_params
							: {};
					$scope.depot.additional_params.headers =
						$scope.depot.additional_params.headers != undefined
							? $scope.depot.additional_params.headers
							: {};
					$scope.depot.additional_params.headers[header.key] = header.value;
				}
			};

			$scope.handleDepotTyeChange = function (selectedType) {
				generateBinaryDepotHeaders();
				moveTempUploadedFileToRightType();
				if (selectedType.toLowerCase() === 'json_v2') {
					// Default mode is permissive, in the future we should add a select on the page
					// to let the user chose the mode
					$scope.depot.parsing_mode = 'PERMISSIVE';
				}
				if (selectedType.toLowerCase() === 'excel') {
					// Default header presence is true for excel files
					$scope.depot.has_header = true;
				}
			};

			$scope.showReadingModeWiki = function (modalId) {
				$('#' + modalId).modal('show');
			};

			$scope.showXmlTagHelp = function (modalId) {
				$('#' + modalId).modal('show');
			};

			$scope.detectCharset = function () {
				if ($scope.depot.id !== undefined) {
					$scope.jobError = {};
					$scope.jobError.mainPosition = true;
					const depotType = $scope.depot.depot_type;

					let charsetQuery;
					if (
						depotType.toLowerCase() === 'json_v2' ||
						depotType.toLowerCase() === 'xml_v2'
					) {
						charsetQuery = RepositoryService.detectCharsetByRepositoryId(
							$scope.depot.id
						);
					} else {
						charsetQuery = DepotService.detectCharset(
							$scope.depot.id,
							depotType
						);
					}
					charsetQuery
						.then(function (response) {
							let charset = response.data;
							if (charset !== undefined && charset !== '') {
								if (!Array.isArray($scope.charsets)) {
									$scope.charsets = [];
								}
								let charsetExist = false;
								for (let i in $scope.charsets) {
									if ($scope.charsets[i].value === charset) {
										charsetExist = true;
										break;
									}
								}
								if (!charsetExist) {
									let charsetObj = {
										label: charset,
										value: charset,
									};
									$scope.charsets.unshift(charsetObj);
								}
								$scope.depot.charset = charset;
							}
						})
						.catch(catchErrors);
				}
			};

			$scope.getFileMaxSize = function () {
				ParametersServices.getFileMaxSize().then(function (response) {
					$scope.fileMaxSize = response.data;
				});
			};

			$scope.checkDate = function () {
				let firstDate = new Date($scope.filter.first_date_value);
				let secondDate = new Date($scope.filter.second_date_value);
				if (secondDate < firstDate) {
					return ($scope.inValidDate = true);
				}
				return ($scope.inValidDate = false);
			};

			$scope.clearBodyIfGet = function () {
				if ($scope.depot.additional_params.method === 'GET') {
					$scope.depot.additional_params.body = null;
				}
			};

			$scope.addHttpIterationHeaderValue = function () {
				$scope.depot.additional_params =
					$scope.depot.additional_params != undefined
						? $scope.depot.additional_params
						: {};
				$scope.depot.additional_params.iteration =
					$scope.depot.additional_params.iteration != undefined
						? $scope.depot.additional_params.iteration
						: {};
				$scope.depot.additional_params.iteration.end_condition_headers =
					$scope.depot.additional_params.iteration.end_condition_headers !=
					undefined
						? $scope.depot.additional_params.iteration.end_condition_headers
						: {};
				let length = Object.keys(
					$scope.depot.additional_params.iteration.end_condition_headers
				).length;
				$scope.depot.additional_params.iteration.end_condition_headers[
					'key' + length
				] = 'value' + length;
			};

			$scope.deleteIterationHeaderValue = function (index) {
				let objIndex = 0;
				for (let i in $scope.depot.additional_params.iteration
					.end_condition_headers) {
					if (objIndex === index) {
						delete $scope.depot.additional_params.iteration
							.end_condition_headers[i];
						break;
					}

					objIndex++;
				}
			};

			$scope.updateIterationHeaderKey = function (key, index) {
				var keys = Object.keys(
					$scope.depot.additional_params.iteration.end_condition_headers
				);
				var oldKey = keys[index];
				$scope.depot.additional_params.iteration.end_condition_headers =
					keys.reduce((acc, val) => {
						if (val === oldKey) {
							acc[key] =
								$scope.depot.additional_params.iteration.end_condition_headers[
									oldKey
								];
						} else {
							acc[val] =
								$scope.depot.additional_params.iteration.end_condition_headers[
									val
								];
						}
						return acc;
					}, {});
			};

			$scope.iterationModeChange = function () {
				delete $scope.depot.additional_params.iteration.end_or_limit;
				delete $scope.depot.additional_params.iteration.iteration_number;
				delete $scope.depot.additional_params.iteration.start;
				delete $scope.depot.additional_params.iteration.variable;
				delete $scope.depot.additional_params.iteration.waiting;
				delete $scope.depot.additional_params.iteration.en_condition_body;
				delete $scope.depot.additional_params.iteration.end_condition_mode;
				delete $scope.depot.additional_params.iteration.is_regex;
				delete $scope.depot.additional_params.iteration.end_condition_headers;
			};

			$scope.openHeaderFieldsSelection = function () {
				if (!$scope.metadata.label) {
					return;
				}
				if (
					$scope.depot.depot_type.toLowerCase() !== 'json_v2' &&
					$scope.depot.depot_type.toLowerCase() !== 'xml_v2' &&
					$scope.depot.depot_type.toLowerCase() !== 'trino' &&
					$scope.depot.depot_type.toLowerCase() !== 'datalink'
				) {
					return;
				}
				let selectionParams;
				let depot = angular.copy($scope.depot);
				let metadata = angular.copy($scope.metadata);
				if ($scope.depot.depot_type.toLowerCase() === 'json_v2') {
					// BUGFIX: Fixes "TypeError: Cannot assign to read only property 'mode' of object".
					// This error occurred when the component was initialized with a default, read-only
					// configuration object. When the user then tried
					// to modify a related form field, AngularJS's data binding would attempt to write
					// to the frozen object, causing a crash.
					//
					// By using angular.copy(), we create a deep, mutable clone of the data. This ensures
					// the component works with a completely isolated and writeable copy, preventing any
					// attempt to mutate the original read-only object.
					selectionParams = {
						id: depot.id,
						label: metadata.label,
						code: metadata.code,
						isActiveDepot: metadata.actif,
						selectedContext: AppSelectorService.getSelectedCtxId(),
						detectTypes: depot.infer_schema,
						readMask: depot.current_version_mask,
						charset: depot.charset,
						path: depot.path, // only for SFTP/HDFS/S3
						parsingMode: depot.parsing_mode.toUpperCase(),
						connectorId: depot.connector ? depot.connector.id : undefined,
						depotType: 'json',
						isMultiLine: depot.multiline, // retrieve from config
						config: { schema: null },
						additionalParams: depot.additional_params,
					};
				} else if ($scope.depot.depot_type.toLowerCase() === 'xml_v2') {
					// BUGFIX: Fixes "TypeError: Cannot assign to read only property 'mode' of object".
					// This error occurred when the component was initialized with a default, read-only
					// configuration object. When the user then tried
					// to modify a related form field, AngularJS's data binding would attempt to write
					// to the frozen object, causing a crash.
					//
					// By using angular.copy(), we create a deep, mutable clone of the data. This ensures
					// the component works with a completely isolated and writeable copy, preventing any
					// attempt to mutate the original read-only object.
					selectionParams = {
						id: depot.id,
						label: metadata.label,
						code: metadata.code,
						isActiveDepot: metadata.actif,
						selectedContext: AppSelectorService.getSelectedCtxId(),
						detectTypes: depot.infer_schema,
						readMask: depot.current_version_mask,
						charset: depot.charset,
						path: depot.path, // only for SFTP/HDFS/S3
						parsingMode: depot.parsing_mode.toUpperCase(),
						connectorId: depot.connector ? depot.connector.id : undefined,
						depotType: 'xml',
						newLineTag: depot.new_line_tag, // retrieve from config
						shouldIgnoreSurroundingSpace: depot.ignore_surrounding_spaces,
						hasNullForEmptyValues: depot.treat_empty_values_as_nulls,
						config: { schema: null },
						additionalParams: depot.additional_params,
					};
				} else if ($scope.depot.depot_type.toLowerCase() === 'trino') {
					selectionParams = {
						id: depot.id,
						label: metadata.label,
						code: metadata.code,
						isActiveDepot: metadata.actif,
						selectedContext: AppSelectorService.getSelectedCtxId(),
						detectTypes: depot.infer_schema,
						connectorId: depot.connector ? depot.connector.id : undefined,
						depotType: 'trino',
						query: depot.query,
						config: { schema: null },
						additionalParams: depot.additional_params,
					};
				} else if ($scope.depot.depot_type.toLowerCase() === 'datalink') {
					selectionParams = {
						id: depot.id,
						label: metadata.label,
						code: metadata.code,
						isActiveDepot: metadata.actif,
						selectedContext: AppSelectorService.getSelectedCtxId(),
						detectTypes: depot.infer_schema,
						connectorId: depot.connector ? depot.connector.id : undefined,
						dataLinkId: depot.data_link_id ? depot.data_link_id : undefined,
						dataLinkUuid: depot.data_link_uuid
							? depot.data_link_uuid
							: undefined,
						depotType: 'datalink',
						config: { schema: null },
						additionalParams: depot.additional_params,
					};
				}
				NgDepot.openHeaderFieldsSelection(
					selectionParams,
					$scope.currentDepotSchema
				);
			};

			/**
			 * private functions
			 */

			function init() {
				initVariables();
				initListeners();

				if (
					($stateParams.id && $stateParams.type !== undefined
						? $stateParams.type
						: $scope.depot.depot_type) ||
					($stateParams.duplicatedId && $stateParams.type !== undefined
						? $stateParams.type
						: $scope.depot.depot_type)
				) {
					// edit
					$scope.isNewDepot = $stateParams.duplicatedId !== undefined;
					$scope.connector = {};
					let withHeaders = true;
					let linkedUetCount = true;
					let depotId =
						$stateParams.id !== undefined
							? $stateParams.id
							: $stateParams.duplicatedId;
					let filesCount = true;
					$scope.jobError = {};
					$scope.jobError.mainPosition = true;
					$scope.savingInProgress = false;

					if ($stateParams.type && $stateParams.type.includes('SQL')) {
						DbSQLDepotService.getDbDepotById(depotId, withHeaders)
							.then(function (response) {
								initDepotData(response.data, false);
							})
							.catch(catchErrors);
					} else if (
						$stateParams.type &&
						$scope.REPOSITORY_V2_TYPES.includes($stateParams.type)
					) {
						if ($stateParams.type.includes('DATALINK')) {
							$scope.isSubscription = true;
							PermissionService.havePermission(
								depotId,
								'edit',
								'data_source'
							).then(function (result) {
								if (result.data) {
									DepotService.getAvailableVersionsForDataLinkRepo(
										depotId
									).then(function (response) {
										$scope.producerProjectVersionCount = response.data.filter(
											(item) => item.current === false
										).length;
									});
								}
							});
						}

						RepositoryService.getRepositoryById(depotId)
							.then(function (response) {
								const notSQL = $stateParams.type !== 'TRINO';
								initDepotData(response.data, notSQL);
							})
							.catch(catchErrors);
					} else if (
						$stateParams.type &&
						$stateParams.type.includes('MONGODB')
					) {
						MongodbDepotService.getMongodbDepotById(depotId, withHeaders)
							.then(function (response) {
								initDepotData(response.data, false);
							})
							.catch(catchErrors);
					} else if ($stateParams.type && $stateParams.type.includes('NEO4J')) {
						Neo4jDepotService.getNeo4jDepotById(depotId, withHeaders)
							.then(function (response) {
								initDepotData(response.data, false);
							})
							.catch(catchErrors);
					} else if ($stateParams.type && $stateParams.type.includes('CSV')) {
						CsvDepotService.getCsvDepotById(depotId, withHeaders)
							.then(function (response) {
								initDepotData(response.data, true);
							})
							.catch(catchErrors);
					} else if (
						$stateParams.type &&
						$stateParams.type.includes('PARQUET')
					) {
						ParquetDepotService.getParquetDepotById(depotId, withHeaders)
							.then(function (response) {
								initDepotData(response.data, true);
							})
							.catch(catchErrors);
					} else if ($stateParams.type && $stateParams.type.includes('JSON')) {
						JsonDepotService.getJsonDepotById(
							depotId,
							withHeaders,
							linkedUetCount,
							filesCount
						)
							.then(function (response) {
								initDepotData(response.data, true);
							})
							.catch(catchErrors);
					} else if ($stateParams.type && $stateParams.type.includes('EXCEL')) {
						ExcelDepotService.getExcelDepotById(
							depotId,
							withHeaders,
							linkedUetCount,
							filesCount
						)
							.then(function (response) {
								initDepotData(response.data, true);
							})
							.catch(catchErrors);
					} else if (
						$stateParams.type &&
						$stateParams.type.includes('BINARY')
					) {
						BinaryDepotService.getBinaryDepotById(
							depotId,
							withHeaders,
							linkedUetCount,
							filesCount
						)
							.then(function (response) {
								initDepotData(response.data, true);
							})
							.catch(catchErrors);
					} else if ($stateParams.type && $stateParams.type.includes('XML')) {
						XmlDepotService.getXmlDepotById(
							depotId,
							withHeaders,
							linkedUetCount,
							filesCount
						)
							.then(function (response) {
								initDepotData(response.data, true);
							})
							.catch(catchErrors);
					} else {
						toaster.pop(
							'error',
							gettextCatalog.getString('Erreur'),
							gettextCatalog.getString('type.non.supported')
						);
					}
					$scope.depot.additional_params =
						$scope.depot.additional_params !== undefined
							? $scope.depot.additional_params
							: {};
					$scope.depot.additional_params.header =
						$scope.depot.additional_params.header !== undefined
							? $scope.depot.additional_params.header
							: {};
				} else {
					$scope.depot = $scope.depot != undefined ? $scope.depot : {};
					$scope.depot.additional_params =
						$scope.depot.additional_params != undefined
							? $scope.depot.additional_params
							: {};
					$scope.depot.additional_params.header =
						$scope.depot.additional_params.header != undefined
							? $scope.depot.additional_params.header
							: {};
					$scope.depot.current_version_mask = '*.*';
					$scope.depot.parsing_mode = 'PERMISSIVE';
					$scope.isNewDepot = true;
					$scope.metadataLoaded = true;
					initLibs();
					initConnector();
					initHeadersSortableOptions();

					if (
						$scope.isNewDepot &&
						$stateParams.duplicatedId == undefined &&
						passedData &&
						passedData.fromAngular
					) {
						$scope.metadata.label = passedData.metadata.label;
						if (passedData.source === 'LOCAL') {
							$scope.isWithConnector = false;
							$scope.depot = {
								connector: {
									id: '',
									lib: '',
									connector_type: 'LOCAL',
									isNatif: true,
								},
							};
						} else if (passedData.source === 'withConnector') {
							$scope.isWithConnector = true;
							const { selection: connector } = passedData;
							$scope.depot = {
								connector: {
									id: connector.id,
									lib: connector.label,
									connector_type: connector.type,
									// isNatif: true,
								},
							};
							ConnectorService.getConnectorById($scope.depot.connector.id).then(
								function (response) {
									$scope.depot.connector = response.data;
									if (
										$scope.depot.connector &&
										$scope.depot.connector.metadata
									) {
										$scope.depot.connector.lib =
											$scope.depot.connector.metadata.label;
									}
									$scope.selectOrUnSelectConnector();
									getMongodbCollections();
									getConnectorsForCurrentDepot();
								}
							);
						} else if (passedData.source === 'withSubscription') {
							$scope.depot = {
								connector: {
									id: '',
									lib: '',
									connector_type: 'LOCAL',
									// isNatif: true,
								},
							};
						}
						$scope.metadata = {
							label: passedData.metadata.label,
							description: passedData.metadata.description,
							actif: passedData.metadata.isActive,
							tags: passedData.metadata.tags.toArray().map((t) => ({
								code: t.label,
								color: t.color,
							})),
						};
					}
				}
			}

			function initVariables() {
				$scope.helpTitleTra = gettextCatalog.getString('Aide Dépôts');
				$scope.SheetTra = "'" + gettextCatalog.getString('Feuil1') + "'!B3:C35";
				$scope.hidePageTitle = true;
				$scope.metadata = {};
				$scope.metadata.code = '';
				$scope.metadata.actif = true;
				$scope.metadata.tags = [];
				$scope.depot = {
					delimiter_csv: ';',
					quote_csv: '',
					has_header: true,
					include_subtree: false,
					infer_schema: true,
					auto_integration: true,
					replace_file: false,
					reset_depot: false,
					sql_query: '',
				};
				$scope.depotFlow = {};
				$scope.selectedCharset = {};
				$scope.headers = [];
				$scope.headersReUploaded = false;
				$scope.initialCharsets = [];
				$scope.checkPermissionData = {};
				$scope.fileMaxSize = undefined;
				$scope.entiteConfig = {};
				$scope.entiteConfig.isDepotType = true;
				$scope.inValidDate = false;
				$scope.permissiveMode = gettextCatalog.getString('PERMISSIVE');
				$scope.dropmalformedMode = gettextCatalog.getString('DROPMALFORMED');
				$scope.failfastMode = gettextCatalog.getString('FAILFAST');
				$scope.localMode = gettextCatalog.getString('Mode Local');
				$scope.parsingModes = [
					$scope.permissiveMode,
					$scope.dropmalformedMode,
					$scope.failfastMode,
				];
				$scope.mongodbAvailableCollections = [];
				$scope.connectorsTypes = DepotUtils.connectorsTypes;
				$scope.isNewDepot = true;
				$scope.saveButtonDisabled = true;
				$scope.filteredreaderTypes = DepotUtils.initReaderTypes;
				$scope.savingInProgress = false;
				$scope.dataModel = {
					save: function () {
						save(true);
					},
					redirectionToList: function () {
						redirectionToList();
					},
				};
				$scope.isNewDepot = true;
				$scope.isWithConnector = false;
				$scope.isSubscription = false;
				$scope.producerProjectVersionCount = 0;
				$scope.hasHeaders = false;
				$scope.sqlTestQuery = '';
				$scope.metadataConfig = {
					htmlId: 'depot',
				};
				$scope.isExtractionPreview = false;
				$scope.moreThanTenColumns = false;
				$scope.gridOptions = {
					data: [],
				};
				$scope.previewModal = { showValuePreview: false, value: '' };

				$scope.dataTypes = DepotUtils.dataTypes;

				$scope.extractHeadersUrl =
					API_BASE_URL_BACKEND +
					'depot/local/headers/extract?ctx=' +
					AppSelectorService.getSelectedCtxId();

				$scope.uploadedFileProcessingDone = {};
				$scope.files = {};
				$scope.fileNamesMapper = {};
				$scope.atLeastOneFileUploaded = false;
				$scope.oldDepotType = undefined;
				$scope.filesListDataGridColumn = {};
				$scope.filesListDataGridColumn.fileName =
					gettextCatalog.getString('Nom du fichier');
				$scope.filesListDataGridColumn.techniqueName = gettextCatalog.getString(
					'Nom technique du fichier'
				);
				$scope.filesListDataGridColumn.importedTime = gettextCatalog.getString(
					"Date et heure d'import"
				);
				$scope.filesListDataGridColumn.actions =
					gettextCatalog.getString('Actions');
				$scope.filesListDataGridColumn.date = gettextCatalog.getString('Date');

				// Files uiGrid
				$scope.filesListDataGridCommonOptions = {
					dataSource: $scope.archivesData,
					paging: {
						enabled: true,
						pageSize: PAGINATIONS_SIZE,
					},
					pager: {
						showPageSizeSelector: true,
						allowedPageSizes: PAGINATIONS_SIZES,
						showInfo: true,
						visible: true,
					},
					filterRow: {
						visible: true,
						applyFilter: 'auto',
					},
					rowAlternationEnabled: true,
					headerFilter: {
						visible: true,
						applyFilter: 'auto',
					},
					showColumnLines: true,
					showRowLines: true,
					allowColumnReordering: true,
					allowColumnResizing: true,
					columnAutoWidth: true,
					showBorders: true,
					columnFixing: {
						enabled: true,
					},
					columns: [
						{
							caption: $scope.filesListDataGridColumn.fileName,
							dataField: 'displayName',
							sortOrder: 'asc',
							cellTemplate: 'fileName',
						},
						{
							caption: $scope.filesListDataGridColumn.techniqueName,
							dataField: 'fileName',
						},
						{
							caption: $scope.filesListDataGridColumn.importedTime,
							dataField: 'creationDate',
							sortingMethod: function (value1, value2) {
								return compareTwoDatesForDxGrid(value1, value2, this.sortOrder);
							},
						},
						{
							caption: $scope.filesListDataGridColumn.actions,
							alignment: 'center',
							cellTemplate: 'actions',
							width: 120,
							allowReordering: false,
						},
					],
				};

				$scope.filesGridOptions = {
					dataSource: $scope.loadFilesData,
					onInitialized: function (e) {
						$scope.filesGridInstance = e.component;
					},
				};

				$scope.remoteFilesGridOptions = {
					dataSource: $scope.loadremotefilesData,
					onInitialized: function (e) {
						$scope.remoteFilesGridInstance = e.component;
					},
				};

				$scope.pendingFilesGridOptions = {
					dataSource: $scope.loadPendingFilesData,
					onInitialized: function (e) {
						$scope.pendingFilesGridInstance = e.component;
					},
				};

				$scope.rejectedFilesGridOptions = {
					dataSource: $scope.loadRejectedFilesData,
					onInitialized: function (e) {
						$scope.rejectedFilesGridInstance = e.component;
					},
				};

				$scope.checkIfHeadersCalculated = function () {
					if ($scope.headers && $scope.headers.length > 0) {
						ModalService.confirm({
							title: gettextCatalog.getString(
								'modal.confirm.repository.json.multiline.change.title'
							),
							content: gettextCatalog.getString(
								'modal.confirm.repository.json.multiline.change.message'
							),
							acceptLabel: gettextCatalog.getString(
								'modal.confirm.repository.json.multiline.change.accept.label'
							),
							cancelLabel: gettextCatalog.getString(
								'modal.confirm.repository.json.multiline.change.cancel.label'
							),
						}).then(
							function () {
								// --- USER CLICKED ACCEPT ---
								// we delete headers and schema
								$scope.depot.headers = null;
								$scope.headers = null;
								$scope.depot.schema = null;
								$scope.currentDepotSchema = null;
								$scope.originalDepotSchema = null;
							},
							function (err) {
								// --- USER CLICKED CANCEL ---
								// We set it to the OPPOSITE of its current (new) value.
								$scope.depot.multiline = !$scope.depot.multiline;
							}
						);
					}
				};

				$scope.archivesDataGridOptions = {
					dataSource: $scope.archivesData,
					paging: {
						enabled: true,
						pageSize: PAGINATIONS_SIZE,
					},
					pager: {
						showPageSizeSelector: true,
						allowedPageSizes: PAGINATIONS_SIZES,
						showInfo: true,
						visible: true,
					},
					filterRow: {
						visible: true,
						applyFilter: 'auto',
					},
					rowAlternationEnabled: true,
					headerFilter: {
						visible: true,
						applyFilter: 'auto',
					},
					showColumnLines: true,
					showRowLines: true,
					allowColumnReordering: true,
					allowColumnResizing: true,
					columnAutoWidth: true,
					showBorders: true,
					columnFixing: {
						enabled: true,
					},
					columns: [
						{
							caption: $scope.filesListDataGridColumn.date,
							dataField: 'date',
							visible: false,
						},
						{
							caption: $scope.filesListDataGridColumn.date,
							dataField: 'displayName',
						},
						{
							caption: $scope.filesListDataGridColumn.actions,
							alignment: 'center',
							cellTemplate: 'actions',
							width: 120,
							allowReordering: false,
						},
					],
					onInitialized: function (e) {
						$scope.gridArchivesInstance = e.component;
					},
				};

				$scope.filesGridOptions = _.merge(
					$scope.filesGridOptions,
					$scope.filesListDataGridCommonOptions
				);

				$scope.remoteFilesGridOptions = _.merge(
					$scope.remoteFilesGridOptions,
					$scope.filesListDataGridCommonOptions
				);

				$scope.pendingFilesGridOptions = _.merge(
					$scope.pendingFilesGridOptions,
					$scope.filesListDataGridCommonOptions
				);

				$scope.rejectedFilesGridOptions = _.merge(
					$scope.rejectedFilesGridOptions,
					$scope.filesListDataGridCommonOptions
				);

				$scope.showTable = false;
				$scope.filtersDataGridColumn = {};
				$scope.filesListDataGridColumn.label =
					gettextCatalog.getString('Libellé');

				$scope.filtersDataGridOptions = {
					dataSource: $scope.filters,
					paging: {
						enabled: true,
						pageSize: PAGINATIONS_SIZE,
					},
					pager: {
						showPageSizeSelector: true,
						allowedPageSizes: PAGINATIONS_SIZES,
						showInfo: true,
						visible: true,
					},
					filterRow: {
						visible: true,
						applyFilter: 'auto',
					},
					rowAlternationEnabled: true,
					headerFilter: {
						visible: true,
						applyFilter: 'auto',
					},
					showColumnLines: true,
					showRowLines: true,
					allowColumnReordering: true,
					allowColumnResizing: true,
					columnAutoWidth: true,
					showBorders: true,
					columnFixing: {
						enabled: true,
					},
					columns: [
						{
							caption: $scope.filesListDataGridColumn.label,
							dataField: 'label',
							allowReordering: false,
						},
						{
							caption: $scope.filesListDataGridColumn.actions,
							alignment: 'center',
							cellTemplate: 'actions',
							width: 120,
							allowReordering: false,
						},
					],
					onInitialized: function (e) {
						$scope.gridFilterExtractionInstance = e.component;
					},
				};

				$scope.isFiltersReady = false;
				$scope.filter = {};
				$scope.filters = [];
				$scope.getDateWithPattern = $rootScope.getDateWithPattern;
				$scope.filtersDateOperators = DepotUtils.filtersDateOperators;
				$scope.deleteElementData = {};
				$scope.elementGraphData = {};

				$scope.permissionData = {};

				$scope.possibleCurrentVersionMaskValues =
					DepotUtils.possibleCurrentVersionMaskValues;

				$scope.possibleSepValues = [',', ';', '|', '\\t'];

				$scope.httpMethods = ['GET', 'POST'];

				$scope.httpIterationModes = DepotUtils.httpIterationModes;

				$scope.httpIterationEndModes = DepotUtils.httpIterationEndModes;

				$scope.limitDisplayedFiles = [10, 100, 1000, 10000, 100000];

				$scope.filtersDateOperators = _.sortBy(
					$scope.filtersDateOperators,
					function (elm) {
						return elm.label.toLowerCase();
					}
				);

				$scope.headersReferencingModes = [];
				AllDepotService.findAllDepotsHeadersReferencingModes().then(function (
					modesRes
				) {
					$scope.headersReferencingModes = modesRes.data;
					$scope.depot.headers_referencing_mode = HEADER_REFERENCING_MODE_LABEL;
				});
				$scope.httpHeadersInheritance = [];
			}

			function initListeners() {
				$(document).ready(function () {
					$('[copy-size]').each(function () {
						var copyEl = $($(this).attr('copy-size'));
						var targetEl = $(this);
						targetEl.width(copyEl.width() + 'px');
						targetEl.height(copyEl.height() + 'px');
					});
				});

				$('#currentVersionMAskSuggestions').on('hidden.bs.modal', function () {
					$scope.readingMaskCopy = false;
				});

				$('#sepSuggestions').on('hidden.bs.modal', function () {
					$scope.sepValueCopy = false;
				});

				$scope.$on('depot:mapping:', function (ev, payload) {
					if (payload !== null) {
						$scope.currentDepotSchema = payload.depotMapping.schema;
						RepositoryService.getHeadersFromSchema(
							payload.depotMapping.schema
						).then(function (response) {
							$scope.headers = formatHeaders(response.data);
						});
					}
				});

				$scope.$on('$destroy', function () {
					$log.debug('depot controller destroyed');
					$('#currentVersionMAskSuggestions').off('hidden.bs.modal');
					$('#sepSuggestions').off('hidden.bs.modal');
				});
			}

			function initHeadersSortableOptions() {
				$scope.sortableOptions = {
					start: function () {
						$scope.oldHeaders = angular.copy($scope.headers);
					},
					stop: function (e, ui) {
						if (
							!_.isEqual($scope.oldHeaders, $scope.headers) &&
							$scope.depot.headers_referencing_mode ===
								HEADER_REFERENCING_MODE_POSITION
						) {
							$scope.saveFileHeadersPosition();
						}
					},
					disabled:
						$scope.depot.headers_referencing_mode ===
							HEADER_REFERENCING_MODE_POSITION ||
						$scope.REPOSITORY_V2_TYPES.includes($scope.depot.depot_type),
				};
			}

			function catchErrors(error) {
				if (
					(error &&
						error.data &&
						(error.data.code == '37' ||
							error.data.code == '38' ||
							error.data.code == '39')) ||
					(error &&
						(error.code == '37' || error.code == '38' || error.code == '39'))
				) {
					$scope.jobError.errorMessage = gettextCatalog.getString(
						'context.unavailable'
					);
				}
				$scope.jobError.error = true;
				$scope.savingInProgress = false;
			}

			function getConnectorsForCurrentDepot() {
				if (
					$scope.depot &&
					$scope.depot.connector &&
					$scope.depot.connector.connector_type != 'LOCAL' &&
					$scope.depot.connector.connector_type != 'SQL'
				) {
					ConnectorService.getConnectorsList(
						undefined,
						$scope.depot.connector.connector_type,
						['WRITE_ONLY'],
						false,
						true
					).then(function (response) {
						$scope.connectors = _.sortBy(response.data, function (elm) {
							return elm.lib.toLowerCase();
						});
						mergeHttpHeaders();
					});
				} else if ($scope.depot.connector.connector_type == 'SQL') {
					ConnectorV2Service.getSimilarDBConnectors($scope.depot.connector.id, [
						'WRITE_ONLY',
					]).then(function (response) {
						$scope.connectors = _.sortBy(
							_.map(response.data, function (elm) {
								return {
									id: elm.id,
									code: elm.metadata.code,
									lib: elm.metadata.label,
									connector_type: $scope.depot.connector.connector_type,
								};
							}),
							function (elm) {
								return elm.lib.toLowerCase();
							}
						);
					});
				}
			}

			function initLibs() {
				if ($scope.isNewDepot) {
					ConnectorService.getConnectorsList(
						undefined,
						undefined,
						['WRITE_ONLY'],
						false,
						true
					).then(function (response) {
						let connectorId = $stateParams.connectorId;
						$scope.connectors = _.sortBy(response.data, function (elm) {
							return elm.lib.toLowerCase();
						});
						if (connectorId) {
							for (let i in $scope.connectors) {
								if ($scope.connectors[i].id == connectorId) {
									$scope.depot.connector = $scope.connectors[i];
									$scope.isWithConnector = true;
									break;
								}
							}
						}
						setNativeConnectorMode($scope.depot.connector);
						filterReaders();
					});
				}
				CommonServices.getCharsets().then(function (response) {
					$scope.charsets = response.data;
					$scope.initialCharsets = $scope.charsets;
					let autoCharset = undefined;
					for (let i in $scope.charsets) {
						if ($scope.charsets[i].value == 'DEFAULT') {
							autoCharset = $scope.charsets[i];
							break;
						}
					}
					$scope.setSelectedCharset(autoCharset);
					filterCharset();
				});
			}

			function getMongodbCollections() {
				if (
					$scope.depot &&
					$scope.depot.connector &&
					$scope.depot.connector.id &&
					$scope.depot.connector.connector_type == 'MONGODB'
				) {
					ConnectorV2Service.getMongodbCollections(
						$scope.depot.connector.id
					).then(function (response) {
						$scope.mongodbAvailableCollections = response.data;
					});
				}
			}

			function createDepotSuccess(returnToList, responseData, type) {
				DepotUtils.notifyOnDepotAction(
					'create',
					true,
					DepotUtils.depotTypeLib(type)
				);
				if (returnToList) {
					$timeout(function () {
						$scope.savingInProgress = false;
						$state.go('depots');
					}, 300);
				} else {
					$timeout(function () {
						$scope.savingInProgress = false;
						$state.go('depots-edit', { id: responseData.id, type: type });
					}, 300);
				}
			}

			function filterReaders() {
				$scope.filterReaders();
				let connectorId =
					$scope.depot.connector_id != undefined
						? $scope.depot.connector_id
						: $scope.depot && $scope.depot.connector
						? $scope.depot.connector.id
						: undefined;
				if (
					$stateParams.id == undefined &&
					$stateParams.duplicatedId == undefined
				) {
					$scope.depot.depot_type =
						$scope.filteredreaderTypes && $scope.filteredreaderTypes[0]
							? $scope.filteredreaderTypes[0].value
							: 'CSV';
				}
				$scope.isWithConnector = Number.isInteger(connectorId);
				getMongodbCollections();
			}

			function filterCharset() {
				$scope.charsets = $scope.initialCharsets;
				$scope.setSelectedCharset();
			}

			function mergeHttpHeaders() {
				$scope.httpHeadersInheritance = [];
				let depotKeys = $scope.depot.additional_params.headers
					? Object.keys($scope.depot.additional_params.headers)
					: [];
				let selectedConnector = angular.copy(
					$scope.connectors.find((c) => c.id == $scope.depot.connector.id)
				);
				let connectorKeys = selectedConnector.http_headers
					? selectedConnector.http_headers
					: [];
				// First, add headers defined in the connector
				for (let key of connectorKeys) {
					$scope.httpHeadersInheritance.push({
						key: key,
						value: '',
						isInherited: true,
					});
				}
				// Second, add the remaining headers defined in the depot
				for (let key of depotKeys) {
					if (connectorKeys.includes(key)) {
						$scope.httpHeadersInheritance[connectorKeys.indexOf(key)].value =
							$scope.depot.additional_params.headers[key];
					} else {
						$scope.httpHeadersInheritance.push({
							key: key,
							value: $scope.depot.additional_params.headers[key],
							isInherited: false,
						});
					}
				}
			}

			function saveDepotSuccess(returnToList, responseData, type) {
				$scope.remoteFilesCount = responseData.files_count;
				DepotUtils.notifyOnDepotAction(
					'save',
					true,
					DepotUtils.depotTypeLib(type)
				);
				if (returnToList) {
					$timeout(function () {
						$state.go('depots');
					}, 300);
				}
				$scope.hasHeaders = responseData.headers.length !== 0;
				$scope.savingInProgress = false;
			}

			function initConnector() {
				if ($scope.isNewDepot && $stateParams.duplicatedId == undefined) {
					$scope.isWithConnector = false;
					$scope.depot.depot_type = 'CSV';
					$scope.depot.connector = { connector_type: 'LOCAL' };
				} else {
					$scope.isWithConnector = $scope.depot.connector
						? $scope.depot.connector.id !== undefined
						: $scope.depot.connector_id != undefined;

					if ($scope.isWithConnector) {
						let connectorId;
						if ($scope.depot.connector) {
							connectorId = $scope.depot.connector.id;
						} else {
							connectorId = $scope.depot.connector_id;
						}
						ConnectorService.getConnectorById(connectorId).then(function (
							response
						) {
							$scope.depot.connector = response.data;
							if ($scope.depot.connector && $scope.depot.connector.metadata) {
								$scope.depot.connector.lib =
									$scope.depot.connector.metadata.label;
							}
							$scope.selectOrUnSelectConnector();
							getMongodbCollections();
							getConnectorsForCurrentDepot();
						});
					} else {
						$scope.depot.connector = { connector_type: 'LOCAL' };
						$scope.selectOrUnSelectConnector();
					}
				}
			}

			function getlinkedUetCount() {
				if ($scope.depot.id && $stateParams.duplicatedId == undefined) {
					EntiteDepotService.getUetCountByDepotId($scope.depot.id).then(
						function (response) {
							$scope.entiteConfig = $scope.entiteConfig
								? $scope.entiteConfig
								: {};
							$scope.entiteConfig.entitieTypesCount = response.data;
						}
					);
				}
			}

			function setLinkedUetCount() {
				$scope.entiteConfig = $scope.entiteConfig ? $scope.entiteConfig : {};
				$scope.entiteConfig.entitieTypesCount = $scope.depot.linked_uet_count;
			}

			function initDepotData(data, notSQL) {
				$scope.depot = data;
				setDataLinkStatusNotice();
				if (data.type === 'JSON_V2') {
					$scope.depot.multiline = data.json_line;
				}
				if (data.type === 'XML_V2') {
					$scope.depot.new_line_tag = data.row_tag;
				} else {
					$scope.depot.new_line_tag = data.new_line_tag;
				}
				$scope.currentDepotSchema = data.schema || null;
				$scope.originalDepotSchema = data.schema || null;
				$scope.depot.id = $scope.isNewDepot ? undefined : $scope.depot.id;
				$scope.depot.depot_type =
					$stateParams.type != undefined
						? $stateParams.type
						: $scope.depot.depot_type;
				$scope.metadata = $scope.isNewDepot
					? $scope.metadata
					: $scope.depot.metadata;
				$scope.headers = formatHeaders($scope.depot.headers);
				$scope.hasHeaders = $scope.headers.length !== 0;
				$scope.metadataLoaded = true;
				setLinkedUetCount();
				initLibs();
				$scope.archives = $scope.depot.archives;
				$scope.initArchivesGrid();
				$scope.setDefaultFetchedFiles();
				initConnector();
				getlinkedUetCount();
				initHeadersSortableOptions();

				if (notSQL) {
					$scope.remoteFilesCount = $scope.depot.files_count;
				}
			}

			// set native connector
			function setNativeConnectorMode(connector) {
				if (connector) {
					for (let i in $scope.connectors) {
						if (connector.id == $scope.connectors[i].id) {
							$scope.depot.connector = $scope.connectors[i];
							break;
						}
					}
				}
			}

			function generateBinaryDepotHeaders() {
				$scope.headers = $scope.isNewDepot ? [] : $scope.headers;
				$scope.sortableOptions.disabled =
					$scope.depot.depot_type === 'BINARY' ||
					$scope.depot.headers_referencing_mode ===
						HEADER_REFERENCING_MODE_LABEL;
				if ($scope.isNewDepot && $scope.depot.depot_type === 'BINARY') {
					$scope.headers = [];
					let fileName = {
						column: gettextCatalog.getString('Nom du fichier'),
						position: 0,
						metadata: false,
						data_type: 'StringType',
					};
					$scope.headers.push(fileName);
					let file = {
						column: gettextCatalog.getString('Fichier'),
						position: 1,
						metadata: false,
						data_type: 'BinaryType',
					};
					$scope.headers.push(file);
					let details = {
						column: gettextCatalog.getString('Détails Dépôt'),
						position: 2,
						metadata: true,
						data_type: 'StringType',
					};
					$scope.headers.push(details);
				}
			}

			function moveTempUploadedFileToRightType() {
				if (
					$scope.isNewDepot &&
					$scope.metadata &&
					$scope.metadata.code &&
					$scope.oldDepotType &&
					$scope.depot.depot_type != $scope.oldDepotType
				) {
					DepotFileService.moveTmpFolderOnTypeUpdate(
						$scope.oldDepotType,
						$scope.depot.depot_type,
						$scope.metadata.code
					).then(function () {});
				}
				$scope.oldDepotType = angular.copy($scope.depot.depot_type);
			}

			function createMetadataHeader(headers) {
				let detailsCreatedOrUpdated = false;
				if (headers != undefined && headers.length > 0) {
					let detailsHeader = _.find(headers, function (elm) {
						return elm.depot_details;
					});
					if (detailsHeader == undefined) {
						let maxPosition = _.max(headers, function (elm) {
							return elm.position;
						});
						if (maxPosition == undefined) {
							maxPosition = {
								position: -1,
							};
						}
						maxPosition.position = +maxPosition.position;
						let details = {
							column: gettextCatalog.getString('Détails Dépôt'),
							position: maxPosition.position + 1,
							depot_details: true,
							data_type: 'StringType',
							realDataType: gettextCatalog.getString(
								$scope.getHeaderRealType('StringType', false)
							),
						};
						headers.push(details);
						detailsCreatedOrUpdated = true;
					}

					if (!$scope.isNewDepot && detailsCreatedOrUpdated) {
						$scope.saveFileHeadersPosition(true);
					}
				}
			}

			function actionsAfterDeleteDepot(type) {
				DepotUtils.notifyOnDepotAction(
					'delete',
					true,
					DepotUtils.depotTypeLib(type)
				);
				$timeout(function () {
					$state.go('depots');
				}, 300);
			}

			function checkReadingMask(flow) {
				if (
					$scope.depot &&
					$scope.depot.connector &&
					$scope.depot.connector.connector_type !== 'HTTP' &&
					!$scope.REPOSITORY_BDD_TYPES.includes($scope.depot.depot_type) &&
					$scope.depot.depot_type !== 'DATALINK' &&
					($scope.depot.current_version_mask === '' ||
						$scope.depot.current_version_mask === undefined)
				) {
					toaster.pop(
						'error',
						gettextCatalog.getString('Erreur'),
						gettextCatalog.getString(
							"Vous devez d'abord saisir un masque de lecture"
						)
					);
					$scope.readingMaskError = true;
					if (flow != undefined) {
						flow.cancel();
					}
					$('#readingMask').focus();
					return false;
				}

				return true;
			}

			function getUploadUrlPath(depotType) {
				let urlPath = $rootScope.getUrl('DEPOT_FILES_UPLOAD');
				if (depotType && typeof depotType === 'string') {
					if (depotType.toLowerCase() === 'csv') {
						urlPath = $rootScope.getUrl('CSV_DEPOT_FILES_UPLOAD');
					} else if (depotType.toLowerCase() === 'binary') {
						urlPath = $rootScope.getUrl('BINARY_DEPOT_FILES_UPLOAD');
					} else if (depotType.toLowerCase() === 'excel') {
						urlPath = $rootScope.getUrl('EXCEL_DEPOT_FILES_UPLOAD');
					} else if (
						depotType.toLowerCase() === 'json' ||
						depotType.toLowerCase() === 'json_v2'
					) {
						urlPath = $rootScope.getUrl('JSON_DEPOT_FILES_UPLOAD');
					} else if (depotType.toLowerCase() === 'parquet') {
						urlPath = $rootScope.getUrl('PARQUET_DEPOT_FILES_UPLOAD');
					} else if (
						depotType.toLowerCase() === 'xml' ||
						depotType.toLowerCase() === 'xml_v2'
					) {
						urlPath = $rootScope.getUrl('XML_DEPOT_FILES_UPLOAD');
					}
				}
				return urlPath;
			}

			function getRootType(type) {
				return type !== undefined ? type.replace(/\((.+?)\)/gi, '') : type;
			}

			function handleUpload() {
				let flow = $scope.currentFlow;
				checkReadingMask(flow);
				flow.opts.query = {
					isDepot: true,
					code: $scope.metadata.code,
					depotType: $scope.depot.depot_type,
				};
				if ($scope.depot.connector) {
					flow.opts.query['connectorId'] = $scope.depot.connector.id;
				}
				flow.opts.headers = {
					'Accept-Language': $rootScope.currentLangCode,
					'x-xsrf-token': $cookies.get('XSRF-TOKEN'),
				};
				// Define the upload URL
				flow.opts.target =
					API_BASE_URL_BACKEND +
					getUploadUrlPath($scope.depot.depot_type) +
					'?isNew=' +
					$scope.isNewDepot +
					'&ctx=' +
					AppSelectorService.getSelectedCtxId() +
					'&project=' +
					$rootScope.currentProjectId;
				$scope.depotFlow.flow = flow;
				$scope.uploadedFileProcessingDone = {};
				for (let i in flow.files) {
					CommonServices.validateFileByReadingMaskGlob(
						flow.files[i].name,
						$scope.depot.current_version_mask
					).then(function (response) {
						if (!response.data) {
							DepotUtils.notifyOnFileUploadError(
								'invalidMask',
								flow.files[i].name
							);
							flow.files[i].cancel();
							delete flow.files[i];
							i--;
						} else {
							if (
								$scope.fileMaxSize &&
								flow.files[i].size > $scope.fileMaxSize
							) {
								DepotUtils.notifyOnFileUploadError(
									'invalidFileSize',
									flow.files[i].name
								);
								flow.files[i].cancel();
								delete flow.files[i];
								i--;
							} else {
								flow.files[i].uniqueIdentifier = i + 1;
							}
						}
						if (i == flow.files.length - 1) {
							if (flow.files[i] && flow.files[i].uniqueIdentifier) {
								$scope.uploadedFileProcessingDone[
									flow.files[i].uniqueIdentifier
								] = false;
							}
							flow.upload();
						}
					});
				}
			}

			function resumeUpload(replaceFile) {
				let flow = $scope.currentFlow;
				let file = $scope.currentUploadFile;
				flow.opts.query = {
					isDepot: true,
					code: $scope.metadata.code,
					depotType: $scope.depot.depot_type,
				};
				flow.opts.headers = {
					'Accept-Language': $rootScope.currentLangCode,
					'x-xsrf-token': $cookies.get('XSRF-TOKEN'),
				};
				$scope.depotFlow.flow = flow;

				angular.forEach(flow.files, function (fileUnit, index) {
					flow.files[index].uniqueIdentifier = index + 1;
				});

				file.resume();
			}

			function save(returnToList) {
				let isValidMask = checkReadingMask();
				$scope.jobError = {};
				$scope.jobError.mainPosition = true;
				cleanIterationEndCondition();
				if (isValidMask) {
					if ($scope.depot.depot_type === 'SQL') {
						$scope.saveDbDepot(returnToList);
					} else if ($scope.depot.depot_type === 'MONGODB') {
						$scope.saveMongodbDepot(returnToList);
					} else if ($scope.depot.depot_type === 'NEO4J') {
						$scope.saveNeo4jDepot(returnToList);
					} else if ($scope.depot.depot_type === 'PARQUET') {
						$scope.saveParquetDepot(returnToList);
					} else if ($scope.depot.depot_type === 'EXCEL') {
						$scope.saveExcelDepot(returnToList);
					} else if ($scope.depot.depot_type === 'BINARY') {
						$scope.saveBinaryDepot(returnToList);
					} else if ($scope.depot.depot_type === 'CSV') {
						$scope.saveCsvDepot(returnToList);
					} else if ($scope.depot.depot_type === 'JSON') {
						$scope.saveJsonDepot(returnToList);
					} else if ($scope.depot.depot_type === 'XML') {
						$scope.saveXmlDepot(returnToList);
					} else if ($scope.depot.depot_type === 'JSON_V2') {
						$scope.saveJsonV2Depot(returnToList, $scope.currentDepotSchema);
					} else if ($scope.depot.depot_type === 'XML_V2') {
						$scope.saveXmlV2Depot(returnToList, $scope.currentDepotSchema);
					} else if ($scope.depot.depot_type === 'TRINO') {
						$scope.saveTrinoDepot(returnToList, $scope.currentDepotSchema);
					} else if ($scope.depot.depot_type === 'DATALINK') {
						$scope.saveSubscriptionDepot(
							returnToList,
							$scope.currentDepotSchema
						);
					} else {
						toaster.pop(
							'error',
							gettextCatalog.getString('Erreur'),
							'Type ' + $scope.depot.depot_type + ' inconnu'
						);
					}
				}
			}

			function formatHeaders(headers) {
				return _.forEach(headers, function (elm) {
					elm.realDataType = gettextCatalog.getString(
						$scope.getHeaderRealType(elm.data_type, elm.list)
					);
				});
			}

			function redirectionToList() {
				$('#confirmationModal').modal('hide');
				$timeout(function () {
					$state.go('depots');
				}, 300);
			}

			function cleanIterationEndCondition() {
				var iteration =
					$scope.depot.additional_params &&
					$scope.depot.additional_params.iteration;
				if (!iteration) return;

				var mode = iteration.end_condition_mode;

				if (mode !== 'BODY') {
					delete iteration.end_condition_body;
					delete iteration.is_regex;
				}
				if (mode !== 'HEADERS') {
					delete iteration.end_condition_headers;
				}
				if (!mode || mode === 'WITHOUT' || mode === undefined) {
					delete iteration.end_condition_body;
					delete iteration.end_condition_headers;
					delete iteration.is_regex;
					delete iteration.end_condition_mode;
				}
			}
		},
	]);
})();
